import { TranslationKeys as K } from "./translationKeys";

export const fallbackTranslations = {
  "en-US": {
    [K.APP_NAME_SHORT]: "Assets",
    [K.APP_NAME_FULL]: "Assets Management",
    [K.NAV_SEARCH_PLACEHOLDER]: "Search pages...",
    [K.NAV_OPEN_NAVIGATION]: "Open navigation",
    [K.NAV_SEARCH]: "Search",
    [K.NAV_CLOSE_SEARCH]: "Close search",
    [K.NAV_SELECT_LANGUAGE]: "Select language",
    [K.NAV_NOTIFICATION]: "Notification",
    [K.NAV_MARK_ALL_READ]: "Mark all as read",
    [K.NAV_MARK_ALL_AS_READ]: "Mark all as read",
    [K.NAV_SHOW_ALL]: "Show all",
    [K.NAV_DISMISS_NOTIFICATION]: "Dismiss notification",
    [K.NAV_JUST_NOW]: "just now",
    [K.NAV_MINS_AGO]: "{count} mins ago",
    [K.NAV_HOURS_AGO]: "{count} hours ago",
    [K.PILL_VIEW_DETAILS]: "View details",
    [K.PILL_EDIT]: "Edit",
    [K.PILL_LOADING]: "Loading...",
    [K.PILL_LOAD_ERROR]: "Failed to load details",
    [K.PILL_ASSET_DETAILS]: "Asset details",
    [K.PILL_CLASS_DETAILS]: "Class details",
    [K.PILL_STUDENT_DETAILS]: "Student details",
    [K.PILL_FIELD_CODE]: "Code",
    [K.PILL_FIELD_NAME]: "Name",
    [K.PILL_FIELD_CATEGORY]: "Category",
    [K.PILL_FIELD_BRAND]: "Brand",
    [K.PILL_FIELD_MODEL]: "Model",
    [K.PILL_FIELD_STATUS]: "Status",
    [K.PILL_FIELD_COURSE]: "Course",
    [K.PILL_FIELD_INSTRUCTOR]: "Instructor",
    [K.PILL_FIELD_ROOM]: "Room",
    [K.PILL_FIELD_START_DATE]: "Start date",
    [K.PILL_FIELD_END_DATE]: "End date",
    [K.PILL_FIELD_STUDENT_CODE]: "Student code",
    [K.PILL_FIELD_FULL_NAME]: "Full name",
    [K.PILL_FIELD_ASSIGNED_DATE]: "Assigned date",
    [K.NAV_PROFILE_SETTINGS]: "Profile",
    [K.NAV_GO_HOME]: "Go to Home",
    [K.NAV_LOG_OUT]: "Log Out",
    [K.NAV_PORTAL]: "Portal",

    [K.MENU_GROUP_ASSET_MANAGEMENT]: "Asset Management",
    [K.MENU_GROUP_PRODUCTION_WORKERS]: "Production & Workers",
    [K.MENU_GROUP_TRAINING]: "Training Mode",
    [K.MENU_GROUP_MAINTENANCE]: "Maintenance",
    [K.MENU_GROUP_ADMINISTRATION]: "Administration",

    [K.ROUTE_DASHBOARD]: "Dashboard",
    [K.ROUTE_ASSETS]: "Assets",
    [K.ROUTE_CATEGORIES]: "Categories",
    [K.ROUTE_DEPARTMENTS]: "Departments",
    [K.ROUTE_ROOMS]: "Class Room",
    [K.ROUTE_HANDOVERS]: "Handovers",
    [K.ROUTE_CONFIGURATION]: "Configuration",
    [K.ROUTE_USERS]: "Users",
    [K.ROUTE_PORTAL_ACCESS]: "Portal Access",
    [K.ROUTE_PRODUCTION_LINES]: "Production Lines",
    [K.ROUTE_PRODUCTION_ORDERS]: "Production Orders",
    [K.ROUTE_PRODUCTION_STEPS]: "Production Steps",
    [K.ROUTE_WORKER_EQUIPMENT]: "Worker Equipment",
    [K.ROUTE_EQUIPMENT_USAGE]: "Equipment Usage",
    [K.ROUTE_WORKING_TIME]: "Working Time",
    [K.ROUTE_COURSES]: "Courses",
    [K.ROUTE_CLASSES]: "Classes",
    [K.ROUTE_STUDENT_ASSIGNMENTS]: "Student Assignments",
    [K.ROUTE_ASSET_MAPPINGS]: "Asset Mappings",
    [K.ROUTE_MAINTENANCE_SCHEDULES]: "Maintenance Schedules",
    [K.ROUTE_MAINTENANCE_RECORDS]: "Maintenance Records",
    [K.ROUTE_SPARE_PARTS]: "Spare Parts",
    [K.ROUTE_SPARE_ASSETS]: "Spare Asset Items",
    [K.ROUTE_ASSET_ITEMS]: "All Asset Items",
    [K.ROUTE_SIGN_IN]: "Sign In",

    [K.PORTAL_ADMIN_NAME]: "Admin Portal",
    [K.PORTAL_STUDENT_NAME]: "Student Portal",
    [K.PORTAL_TEACHER_NAME]: "Teacher Portal",
    [K.PORTAL_MAINTAINER_NAME]: "Technician Portal",
    [K.PORTAL_WORKER_NAME]: "Worker Portal",
    [K.PORTAL_PRODUCTION_MANAGER_NAME]: "Production Manager Portal",

    [K.WORKER_PORTAL_TITLE]: "Worker Portal",
    [K.WORKER_MY_PRODUCTION_LINE]: "My Production Line",
    [K.WORKER_EMPLOYEE_CODE]: "Employee Code",
    [K.WORKER_MY_EQUIPMENT]: "My Equipment",
    [K.WORKER_NO_EQUIPMENT]: "No equipment currently assigned to you.",
    [K.WORKER_ASSIGNED_SINCE]: "Assigned since",
    [K.WORKER_ACTIVE_SESSION]: "Active Session",
    [K.WORKER_NO_ACTIVE_SESSION]: "No active session. Start a session below.",
    [K.WORKER_START_SESSION]: "Start Session",
    [K.WORKER_END_SESSION]: "End Session",
    [K.WORKER_LOG_SESSION]: "Log Session",
    [K.WORKER_SELECT_EQUIPMENT]: "Select equipment",
    [K.WORKER_START_TIME]: "Start Time",
    [K.WORKER_END_TIME]: "End Time",
    [K.WORKER_RUNNING_MINUTES]: "Running Minutes",
    [K.WORKER_DOWNTIME_MINUTES]: "Downtime Minutes",
    [K.WORKER_STITCH_COUNT]: "Stitch Count",
    [K.WORKER_NOTES]: "Notes",
    [K.WORKER_USAGE_HISTORY]: "Usage History",
    [K.WORKER_NO_USAGE_HISTORY]: "No usage history yet.",
    [K.WORKER_SESSION_STARTED]: "Session started successfully.",
    [K.WORKER_SESSION_ENDED]: "Session ended successfully.",
    [K.WORKER_SESSION_START_FAILED]: "Failed to start session.",
    [K.WORKER_SESSION_END_FAILED]: "Failed to end session.",
    [K.WORKER_LOADING]: "Loading your data...",
    [K.WORKER_LOAD_FAILED]: "Failed to load worker data.",
    [K.WORKER_ELAPSED]: "Elapsed",
    [K.WORKER_NO_LINE]: "No production line assigned",
    [K.WORKER_WORKING_CALENDAR]: "Working Calendar",
    [K.WORKER_NO_WORK_EVENTS]: "No working shifts on selected date.",
    [K.WORKER_QR_ATTENDANCE]: "QR Attendance",
    [K.WORKER_QR_CHECKIN]: "Start attendance",
    [K.WORKER_QR_CHECKOUT]: "End attendance",
    [K.WORKER_QR_INPUT_PLACEHOLDER]: "Enter or scan QR code value",
    [K.WORKER_QR_CHECKIN_SUCCESS]: "Attendance started successfully.",
    [K.WORKER_QR_CHECKOUT_SUCCESS]: "Attendance ended successfully.",
    [K.WORKER_QR_ACTION_FAILED]: "QR attendance action failed",
    [K.WORKER_OPEN_CAMERA]: "Open Camera",
    [K.WORKER_CLOSE_CAMERA]: "Close Camera",
    [K.WORKER_CAMERA_UNSUPPORTED]: "Camera QR scanning is not supported on this browser.",
    [K.WORKER_CAMERA_START_FAILED]: "Unable to start camera scanner",
    [K.WORKER_QR_SCANNING]: "Scanning...",
    [K.WORKER_SHIFT_LABEL]: "Shift",
    [K.WORKER_QR_SCAN_CHECKIN_HINT]: "Scan QR code to start attendance for this shift.",
    [K.WORKER_QR_SCAN_CHECKOUT_HINT]: "Scan QR code to end attendance for this shift.",

    [K.ADMIN_WORKING_TIME_GLOBAL_TITLE]: "Global Working Time",
    [K.ADMIN_WORKING_TIME_OVERRIDE_TITLE]: "Per Worker Override",
    [K.ADMIN_WORKING_TIME_TIMEZONE]: "Time Zone",
    [K.ADMIN_WORKING_TIME_TIMEZONE_OPTIONAL]: "Time Zone (optional)",
    [K.ADMIN_WORKING_TIME_CHECKIN_BEFORE]: "Start attendance before (minutes)",
    [K.ADMIN_WORKING_TIME_CHECKIN_AFTER]: "Start attendance after (minutes)",
    [K.ADMIN_WORKING_TIME_CHECKOUT_BEFORE]: "End attendance before (minutes)",
    [K.ADMIN_WORKING_TIME_CHECKOUT_AFTER]: "End attendance after (minutes)",
    [K.ADMIN_WORKING_TIME_SAVE_GLOBAL]: "Save Global Settings",
    [K.ADMIN_WORKING_TIME_SAVE_OVERRIDE]: "Save Override",
    [K.ADMIN_WORKING_TIME_GLOBAL_SAVED]: "Global working time saved.",
    [K.ADMIN_WORKING_TIME_OVERRIDE_SAVED]: "Worker override saved.",
    [K.ADMIN_WORKING_TIME_OVERRIDE_DELETED]: "Override deleted.",
    [K.ADMIN_WORKING_TIME_NO_OVERRIDES]: "No worker overrides yet.",
    [K.ADMIN_WORKING_TIME_LOAD_FAILED]: "Failed to load working time settings.",
    [K.ADMIN_WORKING_TIME_SAVE_FAILED]: "Failed to save working time settings.",
    [K.ADMIN_WORKING_TIME_DELETE_FAILED]: "Failed to delete override.",
    [K.ADMIN_WORKING_TIME_DELETE_CONFIRM]: "Delete this override?",
    [K.ADMIN_WORKING_TIME_OVERRIDE_REQUIRED]: "Please select worker and date range.",
    [K.ADMIN_WORKING_TIME_SHIFT_NAME]: "Shift Name",
    [K.ADMIN_WORKING_TIME_SHIFT_NAME_PH]: "e.g. Morning Shift",
    [K.ADMIN_WORKING_TIME_ADD_SHIFT]: "Add Shift",
    [K.ADMIN_WORKING_TIME_REMOVE_SHIFT]: "Remove",
    [K.ADMIN_WORKING_TIME_WINDOWS_TITLE]: "Start Attendance / End Attendance Windows",
    [K.ADMIN_WORKING_TIME_SHIFTS_TITLE]: "Global Shift Schedules",
    [K.ADMIN_WORKING_TIME_WORKERS_TITLE]: "Worker Shift Assignments",
    [K.ADMIN_WORKING_TIME_ASSIGN_WORKER]: "Assign Shift to Worker",
    [K.ADMIN_WORKING_TIME_EDIT_OVERRIDE]: "Edit Override",
    [K.ADMIN_WORKING_TIME_INHERITS_GLOBAL]: "Inherits global schedule",
    [K.ADMIN_WORKING_TIME_DAYS]: "Working Days",
    [K.ADMIN_WORKING_TIME_START_TIME]: "Start Time",
    [K.ADMIN_WORKING_TIME_END_TIME]: "End Time",
    [K.ADMIN_WORKING_TIME_WORKER_COL]: "Worker",
    [K.ADMIN_WORKING_TIME_DATE_RANGE_COL]: "Date Range",
    [K.ADMIN_WORKING_TIME_CANCEL]: "Cancel",
    [K.ADMIN_WORKING_TIME_ACTIVE_OVERRIDE]: "Active Override",
    [K.ADMIN_WORKING_TIME_EXCLUDE_GLOBAL_SHIFTS]: "When inheriting global, unapply selected shifts",
    [K.ADMIN_WORKING_TIME_EXCLUDED_SHIFTS]: "Excluded",

    [K.PAGE_PROFILE]: "Profile",
    [K.PROFILE_ASSIGNED_PORTALS]: "Assigned portal access",
    [K.PROFILE_NO_PORTAL_ACCESS]: "No portal access assigned",
    [K.PROFILE_NOTIFICATION_HISTORY]: "Notification history",
    [K.PROFILE_NEWEST_FIRST]: "Newest to oldest",
    [K.PROFILE_LOADING_NOTIFICATIONS]: "Loading notifications...",
    [K.PROFILE_FAILED_NOTIFICATIONS]: "Failed to load notifications",
    [K.PROFILE_NOTIFICATION_EMPTY]: "No notifications",
    [K.PROFILE_READ]: "Read",
    [K.PROFILE_UNREAD]: "Unread",
    [K.PROFILE_PAGE_INFO]: "Page {page} of {totalPages}",
    [K.PROFILE_PREVIOUS]: "Previous",
    [K.PROFILE_NEXT]: "Next",
    [K.PROFILE_TIMEZONE_SETTINGS]: "Timezone Settings",
    [K.PROFILE_TIMEZONE_LABEL]: "Your Timezone",
    [K.PROFILE_TIMEZONE_PLACEHOLDER]: "Select your timezone...",
    [K.PROFILE_TIMEZONE_SAVE]: "Save Timezone",
    [K.PROFILE_TIMEZONE_SAVING]: "Saving...",
    [K.PROFILE_TIMEZONE_SAVED]: "Timezone saved!",
    [K.PROFILE_TIMEZONE_ERROR]: "Failed to save timezone",
    [K.PAGE_NO_PORTAL_ACCESS_TITLE]: "Portal Access Required",
    [K.PAGE_NO_PORTAL_ACCESS_BODY_1]: "Your account is active, but no portal access has been assigned yet.",
    [K.PAGE_NO_PORTAL_ACCESS_BODY_2]: "Please contact your administrator to grant access to Student, Teacher, Maintainer, Worker, or Admin portal.",
    [K.PAGE_SIGN_OUT]: "Sign Out",

    [K.STUDENT_PORTAL_TITLE]: "Student Portal",
    [K.TEACHER_PORTAL_TITLE]: "Teacher Portal",
    [K.MAINTAINER_PORTAL_TITLE]: "Technician Portal",

    [K.COMMON_DAILY_DETAILS]: "Daily Details",
    [K.CALENDAR_TODAY]: "Today",
    [K.CALENDAR_PREVIOUS_DAY]: "Previous day",
    [K.CALENDAR_NEXT_DAY]: "Next day",
    [K.CALENDAR_NO_EVENTS_FOR_DAY]: "No events scheduled for this day.",
    [K.CALENDAR_BADGE_CLASS]: "Class",
    [K.CALENDAR_BADGE_ASSIGNMENT]: "Assignment",
    [K.CALENDAR_BADGE_SESSION]: "Session",
    [K.CALENDAR_BADGE_INCIDENT]: "Incident",
    [K.CALENDAR_SHOW_STUDENTS]: "Show students",
    [K.CALENDAR_HIDE_STUDENTS]: "Hide students",

    [K.TABLE_NO_DATA]: "No data",
    [K.TABLE_ITEMS]: "items",
    [K.TABLE_DELETE_SELECTED]: "Delete Selected",
    [K.TABLE_ROWS]: "Rows",
    [K.TABLE_PAGE]: "Page",
    [K.TABLE_PREV]: "Prev",
    [K.TABLE_NEXT]: "Next",
    [K.TABLE_CONFIRM_DELETE_SELECTED]: "Delete selected items?",
    [K.TABLE_BULK_DELETE_FAILED]: "Bulk delete failed",
    [K.MODAL_CLOSE]: "Close",

    [K.SIGNIN_WELCOME_BACK]: "Welcome Back",
    [K.SIGNIN_MICROSOFT_PROMPT]: "Sign in with your Microsoft account",
    [K.SIGNIN_PREPARING]: "Preparing sign-in...",
    [K.SIGNIN_WITH_MICROSOFT]: "Sign In with Microsoft",
    [K.SIGNIN_ORG_ACCOUNT_HINT]: "Using your organizational Microsoft account",
    [K.SIGNIN_ERR_SECURE_BROWSER]: "This browser cannot create a secure PKCE login request. Open this site in Chrome/Safari (not in-app browser) and ensure HTTPS.",
    [K.SIGNIN_ERR_UNKNOWN]: "Unknown sign-in error",
    [K.SIGNIN_ERR_IN_PROGRESS]: "Sign-in is already in progress. Please wait a few seconds and try again.",
    [K.SIGNIN_ERR_PKCE]: "PKCE generation failed on this mobile browser. Open the app in Chrome/Safari (outside in-app browser), then try again.",
    [K.SIGNIN_ERR_UNABLE_START]: "Unable to start Microsoft sign-in ({errorCode}). Try opening in Chrome/Safari and sign in again.",

    [K.STUDENT_MY_ACTIVE_ASSETS]: "My Active Assets",
    [K.STUDENT_READY_FOR_ATTENDANCE]: "Ready to start attendance",
    [K.STUDENT_OPEN_SESSIONS]: "Open Sessions",
    [K.STUDENT_CHECKOUT_TO_COMPLETE]: "End attendance to complete attendance",
    [K.STUDENT_TOTAL_SESSIONS]: "Total Sessions",
    [K.STUDENT_PRACTICE_HISTORY]: "Practice activity history",
    [K.STUDENT_LOAD_FAILED]: "Failed to load student portal",
    [K.STUDENT_SCANNER_UNSUPPORTED]: "Camera QR scanning is not supported on this browser.",
    [K.STUDENT_QR_DETECTED]: "QR detected. Ready to submit.",
    [K.STUDENT_SCANNER_START_FAILED]: "Unable to start camera scanner",
    [K.STUDENT_ENTER_QR_FIRST]: "Scan or enter a QR code value first.",
    [K.STUDENT_QR_CHECKOUT_SUCCESS]: "Start attendance successful.",
    [K.STUDENT_QR_CHECKOUT_FAILED]: "Start attendance failed",
    [K.STUDENT_QR_CHECKIN_SUCCESS]: "End attendance successful.",
    [K.STUDENT_QR_CHECKIN_FAILED]: "End attendance failed",
    [K.STUDENT_SELECT_ASSIGNMENT_FIRST]: "Select an assignment to start attendance.",
    [K.STUDENT_CHECKIN_SUCCESS]: "Start attendance successful.",
    [K.STUDENT_CHECKIN_FAILED]: "Start attendance failed",
    [K.STUDENT_CHECKOUT_SUCCESS]: "End attendance successful.",
    [K.STUDENT_CHECKOUT_FAILED]: "End attendance failed",
    [K.STUDENT_ISSUE_REPORTED]: "Issue reported successfully.",
    [K.STUDENT_ISSUE_REPORT_FAILED]: "Issue report failed",
    [K.STUDENT_QR_SECTION_TITLE]: "Start Attendance / End Attendance",
    [K.STUDENT_QR_SECTION_HINT]: "Scan with camera or enter QR manually to start or end attendance.",
    [K.STUDENT_QR_CODE_VALUE]: "QR code value",
    [K.STUDENT_QR_CHECKOUT_BUTTON]: "Start Attendance",
    [K.STUDENT_QR_CHECKIN_BUTTON]: "End Attendance",
    [K.STUDENT_STOP_CAMERA]: "Stop Camera",
    [K.STUDENT_START_CAMERA]: "Start Camera",
    [K.STUDENT_QR_SCAN_CHECKOUT_HINT]: "Scan the asset QR to start attendance automatically.",
    [K.STUDENT_QR_SCAN_CHECKIN_HINT]: "Scan the asset QR to end attendance automatically.",
    [K.STUDENT_ATTENDANCE_CHECKIN_TITLE]: "Start Attendance",
    [K.STUDENT_ATTENDANCE_CHECKIN_HINT]: "Pick your assigned asset and start a session.",
    [K.STUDENT_SELECT_ASSIGNMENT]: "Select assignment",
    [K.STUDENT_ASSIGNMENT_ROW]: "Assignment",
    [K.STUDENT_CHECKIN_BUTTON]: "Start Attendance",
    [K.STUDENT_REPORT_ISSUE_TITLE]: "Report an Issue",
    [K.STUDENT_REPORT_ISSUE_HINT]: "Share any equipment issue during your current session.",
    [K.STUDENT_SELECT_SESSION]: "Select session",
    [K.STUDENT_SESSION_ROW]: "Session",
    [K.STUDENT_DESCRIBE_EVENT]: "Describe what happened",
    [K.STUDENT_SUBMIT_ISSUE]: "Submit Issue",
    [K.STUDENT_ACTIVE_QR_CHECKOUTS]: "My Ongoing Attendance",
    [K.STUDENT_NO_ACTIVE_QR_CHECKOUTS]: "No ongoing attendance.",
    [K.STUDENT_QR_CHECKOUT_INFO]: "Started at",
    [K.STUDENT_ASSETS_AND_SESSIONS]: "My Assets & Sessions",
    [K.STUDENT_MY_ASSIGNED_ASSETS]: "My Assigned Assets",
    [K.STUDENT_NO_ASSETS_OR_SESSIONS]: "No assigned assets or active sessions.",
    [K.STUDENT_NO_ASSIGNMENTS]: "No assignments yet.",
    [K.STUDENT_ACTIVE]: "Active",
    [K.STUDENT_SESSION_OPEN]: "Session Open",
    [K.STUDENT_UNASSIGNED]: "Unassigned",
    [K.STUDENT_ASSIGNED_INFO]: "Assigned",
    [K.STUDENT_NO_OPEN_SESSION]: "No active session on this asset.",
    [K.STUDENT_NO_ACTIVE_CHECKINS]: "No ongoing attendance.",
    [K.STUDENT_SESSION_INFO]: "Start",
    [K.STUDENT_CHECKOUT_BUTTON]: "End Attendance",
    [K.STUDENT_ATTENDANCE_STATUS]: "Attendance",
    [K.STUDENT_CLASS_START]: "Class starts",
    [K.STUDENT_CLASS_END]: "Class ends",
    [K.STUDENT_LOAD_COURSE_CLASSES_FAILED]: "Failed to load classes for selected course",
    [K.STUDENT_SELECT_CLASS]: "Select class",
    [K.STUDENT_SELECT_CLASS_TO_ENROLL]: "Select a class to enroll.",
    [K.STUDENT_ENROLL_SUCCESS]: "Enrollment completed.",
    [K.STUDENT_ENROLL_FAILED]: "Enrollment failed",
    [K.STUDENT_CANCEL_ENROLLMENT_SUCCESS]: "Enrollment canceled.",
    [K.STUDENT_CANCEL_ENROLLMENT_FAILED]: "Failed to cancel enrollment",
    [K.STUDENT_ENROLL_CLASS_TITLE]: "Find Class And Enroll",
    [K.STUDENT_ENROLL_CLASS_HINT]: "Pick a course, browse classes, and enroll into a class.",
    [K.STUDENT_CURRENT_CLASS]: "Current class",
    [K.STUDENT_CURRENT_CLASS_BADGE]: "Enrolled",
    [K.STUDENT_NOT_ENROLLED]: "You are not enrolled in any class yet.",
    [K.STUDENT_SELECT_COURSE]: "Select course",
    [K.STUDENT_SELECT_COURSE_TO_VIEW_CLASSES]: "Select a course to view available classes.",
    [K.STUDENT_NO_CLASSES_FOR_COURSE]: "No available classes for this course.",
    [K.STUDENT_ENROLL_BUTTON]: "Enroll To Class",
    [K.STUDENT_WITHDRAW_ENROLLMENT_BUTTON]: "Withdraw Enrollment",
    [K.STUDENT_ENROLLMENT_CANCELLATION_CLOSED]: "Enrollment withdrawal window is closed for this class.",
    [K.STUDENT_ONE_CLASS_ONLY_HINT]: "You are already enrolled in a class. Withdraw first to enroll in another class.",
    [K.STUDENT_CLASS_CODE]: "Code",
    [K.STUDENT_CLASS_TEACHER]: "Teacher",
    [K.STUDENT_CLASS_ROOM]: "Room",
    [K.STUDENT_CLASS_DATE_RANGE]: "Date",
    [K.STUDENT_CLASS_AVAILABLE_SLOTS]: "Available slots",
    [K.STUDENT_CLASS_UNLIMITED_SLOTS]: "Unlimited",
    [K.STUDENT_CLASS_SCHEDULE]: "Schedule",
    [K.STUDENT_TRAINING_CALENDAR]: "Training Calendar",
    [K.STUDENT_NO_EVENTS_ON_DATE]: "No training events on selected date.",

    [K.TEACHER_LOAD_FAILED]: "Failed to load teacher workspace",
    [K.TEACHER_ASSIGN_SUCCESS]: "Asset assigned successfully.",
    [K.TEACHER_ASSIGN_FAILED]: "Assignment failed",
    [K.TEACHER_FORCE_RETURN_REASON]: "Enter force return reason:",
    [K.TEACHER_FORCE_RETURN_DEFAULT_REASON]: "Returned by teacher/admin",
    [K.TEACHER_FORCE_RETURN_SUCCESS]: "Asset force-returned.",
    [K.TEACHER_FORCE_RETURN_FAILED]: "Force return failed",
    [K.TEACHER_ISSUE_REPORTED]: "Issue reported successfully.",
    [K.TEACHER_ISSUE_REPORT_FAILED]: "Issue report failed",
    [K.TEACHER_AVAILABLE_ASSETS]: "Available Assets",
    [K.TEACHER_READY_FOR_USE]: "Good condition and ready for use",
    [K.TEACHER_ACTIVE_ASSIGNMENTS]: "Active Assignments",
    [K.TEACHER_IN_STUDENT_HANDS]: "Currently in student hands",
    [K.TEACHER_OPEN_REPORTS]: "Open Reports",
    [K.TEACHER_REPORTED_ISSUES]: "Teacher/student reported issues",
    [K.TEACHER_ASSIGN_TITLE]: "Assign Asset to Student",
    [K.TEACHER_STUDENT_ID]: "Student ID",
    [K.TEACHER_SELECT_CLASS]: "Select class",
    [K.TEACHER_SELECT_AVAILABLE_ASSET]: "Select available asset",
    [K.TEACHER_ASSIGN_NOW]: "Assign Now",
    [K.TEACHER_CHANGE_ASSET]: "Change asset",
    [K.TEACHER_REMOVE_ASSET]: "Remove asset",
    [K.TEACHER_ASSET_REMOVED_SUCCESS]: "Asset removed from student.",
    [K.TEACHER_ASSET_CHANGED_SUCCESS]: "Student asset changed successfully.",
    [K.TEACHER_ASSET_ALREADY_ASSIGNED]: "Selected asset is already assigned to this student.",
    [K.TEACHER_REPORT_ISSUE_TITLE]: "Report Asset Issue",
    [K.TEACHER_REPORT_ISSUE_HINT]: "Submit quick issue reports for ongoing sessions.",
    [K.TEACHER_SESSION_ID]: "Practice Session ID",
    [K.TEACHER_DESCRIBE_ISSUE_IMPACT]: "Describe the issue and impact",
    [K.TEACHER_SEND_ISSUE_REPORT]: "Send Issue Report",
    [K.TEACHER_LIVE_ASSIGNMENTS]: "Live Assignments",
    [K.TEACHER_NO_ACTIVE_ASSIGNMENTS]: "No active assignments.",
    [K.TEACHER_ASSIGNMENT_INFO]: "Assigned",
    [K.TEACHER_FORCE_RETURN]: "Force Return",
    [K.TEACHER_RECENT_ISSUES]: "Recent Issue Feed",
    [K.TEACHER_NO_ISSUES]: "No issues reported yet.",
    [K.TEACHER_SESSION_LABEL]: "Session",
    [K.TEACHER_RESOLVED]: "Resolved",
    [K.TEACHER_OPEN]: "Open",
    [K.TEACHER_NO_DETAILS]: "No details provided.",
    [K.TEACHER_CLASS_START]: "Class starts",
    [K.TEACHER_CLASS_END]: "Class ends",
    [K.TEACHER_TRAINING_CALENDAR]: "Training Calendar",
    [K.TEACHER_NO_EVENTS_ON_DATE]: "No training events on selected date.",

    [K.MAINTAINER_LOAD_FAILED]: "Failed to load maintainer workspace",
    [K.MAINTAINER_STATUS_UPDATED]: "Asset status updated.",
    [K.MAINTAINER_STATUS_UPDATE_FAILED]: "Status update failed",
    [K.MAINTAINER_RESOLVE_SUCCESS]: "Issue #{id} marked resolved.",
    [K.MAINTAINER_RESOLVE_FAILED]: "Issue resolution failed",
    [K.MAINTAINER_DEFAULT_CAUSE]: "Machine",
    [K.MAINTAINER_DEFAULT_RESOLUTION]: "Resolved by maintainer workflow.",
    [K.MAINTAINER_OPEN_REPORTS]: "Open Reports",
    [K.MAINTAINER_AWAITING_DECISION]: "Awaiting maintainer decision",
    [K.MAINTAINER_TRACKED_ASSETS]: "Tracked Assets",
    [K.MAINTAINER_ALL_STATUSES_VISIBLE]: "All statuses visible",
    [K.MAINTAINER_ASSETS_IN_USE]: "Assets In Use",
    [K.MAINTAINER_PROTECTED_TRANSITIONS]: "Protected from risky transitions",
    [K.MAINTAINER_STATUS_CONTROL_TITLE]: "Asset Status Control",
    [K.MAINTAINER_STATUS_CONTROL_HINT]: "Move assets between operational states safely.",
    [K.MAINTAINER_SELECT_ASSET]: "Select asset",
    [K.MAINTAINER_NA]: "N/A",
    [K.MAINTAINER_APPLY_STATUS]: "Apply Status Change",
    [K.MAINTAINER_OPEN_ISSUE_QUEUE]: "Open Issue Queue",
    [K.MAINTAINER_NO_OPEN_ISSUES]: "No open issues right now.",
    [K.MAINTAINER_ISSUE_SESSION_LABEL]: "Issue",
    [K.MAINTAINER_NO_DESCRIPTION]: "No description",
    [K.MAINTAINER_RESOLVE]: "Resolve",
    [K.MAINTAINER_STATUS_DISTRIBUTION]: "Status Distribution",
    [K.MAINTAINER_STATUS_OPERATIONAL]: "Operational",
    [K.MAINTAINER_STATUS_MAINTENANCE]: "Under Maintenance",
    [K.MAINTAINER_STATUS_BROKEN]: "Broken",
    [K.MAINTAINER_STATUS_LOANED]: "Loaned",
    [K.MAINTAINER_STATUS_RETIRED]: "Retired",
    [K.MAINTAINER_REPORTER]: "Reporter",
    [K.MAINTAINER_CATEGORY_LABEL]: "Category",
    [K.MAINTAINER_DATETIME_LABEL]: "Reported at",
    [K.MAINTAINER_ROOM_LABEL]: "Room",
    [K.MAINTAINER_ASSET_LABEL]: "Asset",
    [K.MAINTAINER_RESOLUTION_FORM_TITLE]: "Resolve Incident",
    [K.MAINTAINER_RESOLUTION_TYPE]: "Resolution type",
    [K.MAINTAINER_SELECT_RESOLUTION]: "Select resolution type",
    [K.MAINTAINER_RESOLUTION_DETAIL]: "Detailed action taken",
    [K.MAINTAINER_RESOLUTION_DETAIL_PLACEHOLDER]: "Describe exactly what was done to fix the issue...",
    [K.MAINTAINER_CANCEL]: "Cancel",
    [K.MAINTAINER_SUBMIT_RESOLUTION]: "Mark as Resolved",

    // Phase 14 lifecycle
    MAINTAINER_STATUS_PENDING: "Pending Maintenance",
    MAINTAINER_INCIDENT_CALENDAR: "Incident Calendar",
    MAINTAINER_INCIDENT_DETAILS: "Incident Details",
    MAINTAINER_NO_EVENTS_ON_DATE: "No incidents on selected date.",
    MAINTAINER_JOB_INCIDENT: "Incident",
    MAINTAINER_JOB_SCHEDULED: "Scheduled",
    MAINTAINER_JOB_STATUS_PENDING: "Awaiting Technician",
    MAINTAINER_JOB_STATUS_IN_PROGRESS: "In Progress",
    MAINTAINER_START_WORK: "Start Work",
    MAINTAINER_START_WORK_SUCCESS: "Work started. Asset is now Under Maintenance.",
    MAINTAINER_START_WORK_FAILED: "Failed to start work",
    MAINTAINER_DECOMMISSION: "Decommission",
    MAINTAINER_DECOMMISSION_SUCCESS: "Asset has been decommissioned.",
    MAINTAINER_DECOMMISSION_FAILED: "Decommission failed",
    MAINTAINER_DECOMMISSION_FORM_TITLE: "Decommission Asset",
    MAINTAINER_DECOMMISSION_WARNING: "This action is irreversible. The asset will be permanently retired.",
    MAINTAINER_DECOMMISSION_REASON_PLACEHOLDER: "State the reason for decommissioning this asset...",
    MAINTAINER_CONFIRM_DECOMMISSION: "Confirm Decommission",
    MAINTAINER_RESOLVE_SUCCESS_LIFECYCLE: "Job resolved. Asset is now Operational.",
    MAINTAINER_QUEUE_HINT: "Shows both incident-triggered and scheduled maintenance jobs.",
    MAINTAINER_JOB_LABEL: "Job",
    MAINTAINER_ASSIGNED_TO: "Assigned to",
    MAINTAINER_SLA_DUE: "SLA Due",

    [K.INCIDENT_CATEGORY]: "Incident category",
    [K.INCIDENT_SELECT_CATEGORY]: "Select incident category",

    [K.ADMIN_TABLE_FETCH_FAILED]: "Failed to fetch",
    [K.ADMIN_TABLE_SAVE_FAILED]: "Failed to save",
    [K.ADMIN_TABLE_DELETE_FAILED]: "Failed to delete",
    [K.ADMIN_TABLE_UNKNOWN_ERROR]: "Unknown error",
    [K.ADMIN_TABLE_CREATED_SUCCESSFULLY]: "created successfully",
    [K.ADMIN_TABLE_UPDATED_SUCCESSFULLY]: "updated successfully",
    [K.ADMIN_TABLE_DELETED_SUCCESSFULLY]: "deleted successfully",
    [K.ADMIN_TABLE_DELETED_SELECTED]: "Deleted selected",
    [K.ADMIN_TABLE_DELETE_SELECTED_FAILED]: "Failed to delete selected",
    [K.ADMIN_TABLE_CONFIRM_DELETE_CATEGORY]: "Are you sure you want to delete this category?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_DEPARTMENT]: "Are you sure you want to delete this department?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_COURSE]: "Are you sure you want to delete this course?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_CLASS]: "Are you sure you want to delete this class?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_MAPPING]: "Are you sure you want to delete this mapping?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_LINE]: "Are you sure you want to delete this production line?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_ORDER]: "Are you sure you want to delete this production order?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_STEP]: "Are you sure you want to delete this production step?",
    [K.ADMIN_TABLE_PRODUCTION_ORDER]: "Production Order",
    [K.ADMIN_TABLE_PRODUCTION_ORDERS]: "Production Orders",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_NAME]: "Order Name",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_CODE]: "Order Code",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_BATCH_NUMBER]: "Batch Number",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_LOT_NUMBER]: "Lot Number",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_TARGET_QUANTITY]: "Target Quantity",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_PRIORITY]: "Priority",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_PLANNED_START]: "Planned Start",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_PLANNED_END]: "Planned End",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_ACTUAL_START]: "Actual Start",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_ACTUAL_END]: "Actual End",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_SHIFT_CODE]: "Shift Code",
    [K.ADMIN_TABLE_ENTER_PRODUCTION_ORDER_NAME]: "Enter order name",
    [K.ADMIN_TABLE_ENTER_PRODUCTION_ORDER_CODE]: "Enter order code (e.g., ORD-001)",
    [K.ADMIN_TABLE_SELECT_PRODUCTION_ORDER]: "Select Production Order",
    [K.ADMIN_TABLE_PRODUCTION_STEP]: "Production Step",
    [K.ADMIN_TABLE_PRODUCTION_STEPS]: "Production Steps",
    [K.ADMIN_TABLE_PRODUCTION_STEP_NAME]: "Step Name",
    [K.ADMIN_TABLE_PRODUCTION_STEP_CODE]: "Step Code",
    [K.ADMIN_TABLE_PRODUCTION_STEP_SEQUENCE]: "Sequence",
    [K.ADMIN_TABLE_ENTER_PRODUCTION_STEP_NAME]: "Enter step name",
    [K.ADMIN_TABLE_ENTER_PRODUCTION_STEP_CODE]: "Enter step code",
    [K.ADMIN_TABLE_ADD]: "Add",
    [K.ADMIN_TABLE_ADD_NEW]: "Add New",
    [K.ADMIN_TABLE_CREATE]: "Create",
    [K.ADMIN_TABLE_CREATE_NEW]: "Create New",
    [K.ADMIN_TABLE_UPDATE]: "Update",
    [K.ADMIN_TABLE_CANCEL]: "Cancel",
    [K.ADMIN_TABLE_EDIT]: "Edit",
    [K.ADMIN_TABLE_DELETE]: "Delete",
    [K.ADMIN_TABLE_ACTIONS]: "Actions",
    [K.ADMIN_TABLE_LOADING]: "Loading...",
    [K.ADMIN_TABLE_ALL]: "All",
    [K.ADMIN_TABLE_NA]: "N/A",
    [K.ADMIN_TABLE_YES]: "Yes",
    [K.ADMIN_TABLE_NO]: "No",
    [K.ADMIN_TABLE_OPTIONAL]: "Optional",
    [K.ADMIN_TABLE_REQUIRED]: "Required",
    [K.ADMIN_TABLE_CODE]: "Code",
    [K.ADMIN_TABLE_NAME]: "Name",
    [K.ADMIN_TABLE_DESCRIPTION]: "Description",
    [K.ADMIN_TABLE_STATUS]: "Status",
    [K.ADMIN_TABLE_STATUSES]: "Statuses",
    [K.ADMIN_TABLE_ACTIVE]: "Active",
    [K.ADMIN_TABLE_IN_USE]: "In Use",
    [K.ADMIN_TABLE_INACTIVE]: "Inactive",
    [K.ADMIN_TABLE_CATEGORY]: "Category",
    [K.ADMIN_TABLE_CATEGORIES]: "categories",
    [K.ADMIN_TABLE_CATEGORY_NAME]: "Category Name",
    [K.ADMIN_TABLE_DEPARTMENT]: "Department",
    [K.ADMIN_TABLE_DEPARTMENTS]: "departments",
    [K.ADMIN_TABLE_DEPARTMENT_CODE]: "Department Code",
    [K.ADMIN_TABLE_DEPARTMENT_NAME]: "Department Name",
    [K.ADMIN_TABLE_COURSE]: "Course",
    [K.ADMIN_TABLE_COURSES]: "courses",
    [K.ADMIN_TABLE_COURSE_NAME]: "Course Name",
    [K.ADMIN_TABLE_COURSE_CODE]: "Course Code",
    [K.ADMIN_TABLE_CLASS]: "Class",
    [K.ADMIN_TABLE_CLASSES]: "classes",
    [K.ADMIN_TABLE_CLASS_NAME]: "Class Name",
    [K.ADMIN_TABLE_CLASS_CODE]: "Class Code",
    [K.ADMIN_TABLE_ASSET]: "Asset",
    [K.ADMIN_TABLE_MAPPING]: "Mapping",
    [K.ADMIN_TABLE_MAPPINGS]: "mappings",
    [K.ADMIN_TABLE_PRODUCTION_LINE]: "Production Line",
    [K.ADMIN_TABLE_PRODUCTION_LINES]: "production lines",
    [K.ADMIN_TABLE_DURATION_HOURS]: "Duration (Hours)",
    [K.ADMIN_TABLE_START_DATE]: "Start Date",
    [K.ADMIN_TABLE_END_DATE]: "End Date",
    [K.ADMIN_TABLE_MAX_STUDENTS]: "Max Students",
    [K.ADMIN_TABLE_CANCEL_ENROLLMENT_WINDOW_DAYS]: "Enrollment Cancellation Window (days before start)",
    [K.ADMIN_TABLE_LINE_NAME]: "Line Name",
    [K.ADMIN_TABLE_LINE_CODE]: "Line Code",
    [K.ADMIN_TABLE_ORDER_CODE]: "Order Code",
    [K.ADMIN_TABLE_CAPACITY]: "Capacity",
    [K.ADMIN_TABLE_SEARCH_NAME_DESCRIPTION]: "Search name, description",
    [K.ADMIN_TABLE_SEARCH_CODE_NAME]: "Search code, name",
    [K.ADMIN_TABLE_SEARCH_NAME_CODE]: "Search name, code",
    [K.ADMIN_TABLE_SEARCH_ASSET_COURSE]: "Search asset, course",
    [K.ADMIN_TABLE_SEARCH_NAME_EMAIL_DEPARTMENT]: "Search name, email, department",
    [K.ADMIN_TABLE_SEARCH_DELIVERED_RECEIVED_BY]: "Search delivered by, received by",
    [K.ADMIN_TABLE_ENTER_COURSE_NAME]: "Enter course name",
    [K.ADMIN_TABLE_ENTER_COURSE_CODE_EXAMPLE]: "Enter course code (e.g., CS101)",
    [K.ADMIN_TABLE_ENTER_COURSE_DESCRIPTION]: "Enter course description",
    [K.ADMIN_TABLE_ENTER_DURATION_HOURS]: "Enter duration in hours",
    [K.ADMIN_TABLE_SELECT_COURSE]: "Select a course",
    [K.ADMIN_TABLE_SELECT_ASSET]: "Select an asset",
    [K.ADMIN_TABLE_SELECT_DEPARTMENT]: "Select Department",
    [K.ADMIN_TABLE_REQUIRED_FOR_COURSE]: "Required for Course",
    [K.ADMIN_TABLE_ENTER_CLASS_NAME]: "Enter class name",
    [K.ADMIN_TABLE_ENTER_CLASS_CODE]: "Enter class code",
    [K.ADMIN_TABLE_ENTER_CLASS_DESCRIPTION]: "Enter class description",
    [K.ADMIN_TABLE_ENTER_MAX_STUDENTS]: "Enter max students",
    [K.ADMIN_TABLE_ENTER_CANCEL_ENROLLMENT_WINDOW_DAYS]: "Enter number of days",
    [K.ADMIN_TABLE_ENTER_LINE_NAME]: "Enter line name",
    [K.ADMIN_TABLE_ENTER_LINE_CODE]: "Enter line code",
    [K.ADMIN_TABLE_ENTER_ORDER_CODE]: "Enter order code",
    [K.ADMIN_TABLE_ENTER_CAPACITY]: "Enter capacity",
    [K.ADMIN_TABLE_UNKNOWN]: "Unknown",
    [K.ADMIN_TABLE_DATE]: "Date",
    [K.ADMIN_TABLE_TYPE]: "Type",
    [K.ADMIN_TABLE_TYPES]: "Types",
    [K.ADMIN_TABLE_NOTES]: "Notes",
    [K.ADMIN_TABLE_PROGRESS]: "Progress",
    [K.ADMIN_TABLE_QUANTITY]: "Quantity",
    [K.ADMIN_TABLE_UNIT_PRICE]: "Unit Price",
    [K.ADMIN_TABLE_BRAND]: "Brand",
    [K.ADMIN_TABLE_MODEL]: "Model",
    [K.ADMIN_TABLE_SPECIFICATION]: "Specification",
    [K.ADMIN_TABLE_ASSET_CODE]: "Asset Code",
    [K.ADMIN_TABLE_ASSET_NAME]: "Asset Name",
    [K.ADMIN_TABLE_SELECT_CATEGORY]: "Select Category",
    [K.ADMIN_TABLE_SELECT_UNIT]: "Select Unit",
    [K.ADMIN_TABLE_SELECT_STATUS_OPTIONAL]: "Select Status (Optional)",
    [K.ADMIN_TABLE_SELECT_COUNTRY_OF_ORIGIN_OPTIONAL]: "Select Country of Origin (Optional)",
    [K.ADMIN_TABLE_SEARCH_CODE_NAME_BRAND_MODEL]: "Search code, name, brand, model",
    [K.ADMIN_TABLE_ROOM]: "Room",
    [K.ADMIN_TABLE_ROOM_NAME]: "Room Name",
    [K.ADMIN_TABLE_ROOM_ASSETS]: "Room Assets",
    [K.ADMIN_TABLE_WORKING_ASSETS]: "Working Assets",
    [K.ADMIN_TABLE_ADD_ASSET_TO_ROOM]: "Add Asset to Room",
    [K.ADMIN_TABLE_ASSET_CREATION_HANDOVER_ONLY]: "Asset creation is now available only in Handovers. Please create new room assets from the Handovers screen.",
    [K.ADMIN_TABLE_WORKING_ASSET_CREATION_HANDOVER_ONLY]: "Working asset creation is now available only in Handovers. Please create new production line assets from the Handovers screen.",
    [K.ADMIN_TABLE_CURRENT_ASSETS]: "Current Assets",
    [K.ADMIN_TABLE_SERIAL]: "Serial",
    [K.ADMIN_TABLE_SERIAL_NUMBER]: "Serial Number",
    [K.ADMIN_TABLE_SERIAL_NUMBERS]: "Serial Numbers",
    [K.ADMIN_TABLE_SERIAL_NUMBERS_HINT]: "Enter one serial per line (or comma-separated). Count must match quantity.",
    [K.ADMIN_TABLE_SERIAL_NUMBER_EXAMPLE]: "e.g., SN-12345",
    [K.ADMIN_TABLE_CONDITION]: "Condition",
    [K.ADMIN_TABLE_SELECT_CONDITION_OPTIONAL]: "Select Condition (Optional)",
    [K.ADMIN_TABLE_REMARKS]: "Remarks",
    [K.ADMIN_TABLE_ADDITIONAL_REMARKS]: "Additional remarks...",
    [K.ADMIN_TABLE_QR_CODE]: "QR Code",
    [K.ADMIN_TABLE_VIEW_QR]: "View QR",
    [K.ADMIN_TABLE_SPARE_PARTS]: "Spare Parts",
    [K.ADMIN_TABLE_NO_LOCATION]: "No Location",
    [K.ADMIN_TABLE_LOCATION]: "Location",
    [K.ADMIN_TABLE_REFRESH]: "Refresh",
    [K.ADMIN_TABLE_SEARCH]: "Search...",
    [K.ADMIN_TABLE_DATE_ASSIGNED]: "Date Assigned",
    [K.ADMIN_TABLE_ASSIGNED_TO]: "Assigned To",
    [K.ADMIN_TABLE_ASSIGNED_STUDENT]: "Student",
    [K.ADMIN_TABLE_ASSIGNED_WORKER]: "Worker",
    [K.ADMIN_TABLE_MUST_UNASSIGN_FIRST]: "must be unassigned first",
    [K.ASSET_TYPE_SPARE]: "Spare",
    [K.ASSET_TYPE_ROOM]: "Room",
    [K.ASSET_TYPE_PRODUCTION]: "Production",
    [K.ADMIN_TABLE_ASSET_QR_CODE]: "Asset QR Code",
    [K.ADMIN_TABLE_REMOVE]: "Remove",
    [K.ADMIN_TABLE_ASSET_ADDED_TO_ROOM_SUCCESSFULLY]: "Asset added to room successfully",
    [K.ADMIN_TABLE_ASSET_ADDED_TO_ROOM_SUCCESSFULLY_QR]: "Asset added to room successfully. QR: {qr}",
    [K.ADMIN_TABLE_CONFIRM_DELETE_ASSET]: "Are you sure you want to delete this asset?",
    [K.ADMIN_TABLE_FAILED_ADD_ASSET]: "Failed to add asset",
    [K.ADMIN_TABLE_FAILED_REMOVE_ASSET]: "Failed to remove asset",
    [K.ADMIN_TABLE_CONFIRM_DELETE_ROOM]: "Are you sure you want to delete this room?",
    [K.ADMIN_TABLE_CONFIRM_REMOVE_ASSET_FROM_ROOM]: "Are you sure you want to remove this asset from the room?",
    [K.ADMIN_TABLE_ASSIGNMENT]: "Assignment",
    [K.ADMIN_TABLE_ASSIGNMENTS]: "assignments",
    [K.ADMIN_TABLE_WORKER]: "Worker",
    [K.ADMIN_TABLE_EQUIPMENT]: "Equipment",
    [K.ADMIN_TABLE_SELECT_WORKER]: "Select Worker",
    [K.ADMIN_TABLE_SELECT_EQUIPMENT]: "Select Equipment",
    [K.ADMIN_TABLE_ASSIGNED_DATE]: "Assigned Date",
    [K.ADMIN_TABLE_UNASSIGNED_DATE]: "Unassigned Date",
    [K.ADMIN_TABLE_UNASSIGNED_DATE_OPTIONAL]: "Unassigned Date (Optional)",
    [K.ADMIN_TABLE_UNASSIGNED]: "Unassigned",
    [K.ADMIN_TABLE_SEARCH_WORKER_EQUIPMENT]: "Search worker, equipment",
    [K.ADMIN_TABLE_ADD_WORKER_EQUIPMENT_ASSIGNMENT]: "Add Worker Equipment Assignment",
    [K.ADMIN_TABLE_EDIT_WORKER_EQUIPMENT_ASSIGNMENT]: "Edit Worker Equipment Assignment",
    [K.ADMIN_TABLE_CONFIRM_DELETE_ASSIGNMENT]: "Are you sure you want to delete this assignment?",
    [K.ADMIN_TABLE_REFERENCE_VALIDATION_ERRORS]: "Cannot save assignment due to reference validation errors:",
    [K.ADMIN_TABLE_HANDOVER]: "Handover",
    [K.ADMIN_TABLE_HANDOVER_DATE]: "Handover Date",
    [K.ADMIN_TABLE_HANDOVER_DETAILS]: "Handover Details",
    [K.ADMIN_TABLE_ADD_ASSET_TO_HANDOVER]: "Add Asset to Handover",
    [K.ADMIN_TABLE_ADD_DETAIL]: "Add Detail",
    [K.ADMIN_TABLE_CURRENT_DETAILS]: "Current Details",
    [K.ADMIN_TABLE_DETAILS]: "Details",
    [K.ADMIN_TABLE_DELIVERED_BY]: "Delivered By",
    [K.ADMIN_TABLE_RECEIVED_BY]: "Received By",
    [K.ADMIN_TABLE_SELECT_ROOM]: "Select Room",
    [K.ADMIN_TABLE_TARGET_PRODUCTION_LINE_OPTIONAL]: "Target Production Line (Optional)",
    [K.ADMIN_TABLE_NONE_ROOM_ASSET_ONLY]: "None (Room Asset Only)",
    [K.ADMIN_TABLE_TARGET_LOCATION]: "Target",
    [K.ADMIN_TABLE_SELECT_TARGET_LOCATION]: "Select target",
    [K.ADMIN_TABLE_QUANTITY_EXAMPLE]: "e.g., 5",
    [K.ADMIN_TABLE_SERIAL_COUNT_MUST_MATCH_QUANTITY]: "Serial numbers count must match quantity",
    [K.ADMIN_TABLE_ASSET_AND_SERIAL_REQUIRED]: "Asset and serial number are required",
    [K.ADMIN_TABLE_SERIAL_ALREADY_STAGED]: "This serial number is already added",
    [K.ADMIN_TABLE_TARGET_REQUIRED]: "Please select a target",
    [K.ADMIN_TABLE_ADD_ITEM]: "Add",
    [K.ADMIN_TABLE_STAGED_ITEMS]: "Staged Items",
    [K.ADMIN_TABLE_STAGED_ITEMS_EMPTY]: "No items added yet",
    [K.ADMIN_TABLE_PENDING_GROUPED_SUMMARY]: "Pending grouped summary",
    [K.ADMIN_TABLE_CONDITION_AT_HANDOVER]: "Condition at Handover",
    [K.ADMIN_TABLE_CONDITION_EXAMPLE]: "e.g., Good, Fair, Poor",
    [K.ADMIN_TABLE_DETAIL_ADDED_SUCCESSFULLY]: "Detail added successfully",
    [K.ADMIN_TABLE_DETAIL_DELETED_SUCCESSFULLY]: "Detail deleted successfully",
    [K.ADMIN_TABLE_FAILED_ADD_DETAIL]: "Failed to add detail",
    [K.ADMIN_TABLE_FAILED_DELETE_DETAIL]: "Failed to delete detail",
    [K.ADMIN_TABLE_CONFIRM_DELETE_HANDOVER]: "Are you sure you want to delete this handover?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_DETAIL]: "Are you sure you want to delete this detail?",
    [K.ADMIN_TABLE_USAGE_LOG]: "Usage log",
    [K.ADMIN_TABLE_USAGE_LOGS]: "usage logs",
    [K.ADMIN_TABLE_LOG_EQUIPMENT_USAGE]: "Log Equipment Usage",
    [K.ADMIN_TABLE_LOG_USAGE]: "Log Usage",
    [K.ADMIN_TABLE_START_TIME]: "Start Time",
    [K.ADMIN_TABLE_END_TIME]: "End Time",
    [K.ADMIN_TABLE_END_TIME_OPTIONAL]: "End Time (Optional)",
    [K.ADMIN_TABLE_RUNNING_MINUTES]: "Running Minutes",
    [K.ADMIN_TABLE_RUNNING_MINUTES_EXAMPLE]: "e.g., 480",
    [K.ADMIN_TABLE_DOWNTIME_MINUTES]: "Downtime Minutes",
    [K.ADMIN_TABLE_DOWNTIME_MINUTES_EXAMPLE]: "e.g., 30",
    [K.ADMIN_TABLE_STITCH_COUNT_OPTIONAL]: "Stitch Count (Optional)",
    [K.ADMIN_TABLE_STITCH_COUNT_EXAMPLE]: "e.g., 5000",
    [K.ADMIN_TABLE_ADD_NOTES_USAGE]: "Add any notes about the usage",
    [K.ADMIN_TABLE_SELECT_PRODUCTION_LINE]: "Select Production Line",
    [K.ADMIN_TABLE_SELECT_PRODUCTION_LINE_FIRST]: "Select a production line first",
    [K.ADMIN_TABLE_CONFIRM_DELETE_USAGE_LOG]: "Are you sure you want to delete this usage log?",
    [K.ADMIN_TABLE_REFERENCE_VALIDATION_ERRORS_USAGE_LOG]: "Cannot save usage log due to reference validation errors:",
    [K.ADMIN_TABLE_EDIT_USAGE_LOG]: "Edit Usage Log",
    [K.ADMIN_TABLE_SCHEDULE]: "Schedule",
    [K.ADMIN_TABLE_SCHEDULES]: "schedules",
    [K.ADMIN_TABLE_FREQUENCY]: "Frequency",
    [K.ADMIN_TABLE_FREQUENCY_DAYS_HOURS]: "{value} days/hours",
    [K.ADMIN_TABLE_FREQUENCY_DAYS_OR_HOURS]: "Frequency (days or hours)",
    [K.ADMIN_TABLE_LAST_MAINTENANCE]: "Last Maintenance",
    [K.ADMIN_TABLE_LAST_MAINTENANCE_DATE]: "Last Maintenance Date",
    [K.ADMIN_TABLE_NEXT_DUE]: "Next Due",
    [K.ADMIN_TABLE_NEXT_DUE_DATE]: "Next Due Date",
    [K.ADMIN_TABLE_SELECT_MAINTENANCE_TYPE]: "Select Maintenance Type",
    [K.ADMIN_TABLE_ADD_MAINTENANCE_SCHEDULE]: "Add Maintenance Schedule",
    [K.ADMIN_TABLE_EDIT_MAINTENANCE_SCHEDULE]: "Edit Maintenance Schedule",
    [K.ADMIN_TABLE_ADD_NEW_MAINTENANCE_SCHEDULE]: "Add New Maintenance Schedule",
    [K.ADMIN_TABLE_SEARCH_ASSET_DESCRIPTION]: "Search asset, description",
    [K.ADMIN_TABLE_CONFIRM_DELETE_SCHEDULE]: "Are you sure you want to delete this schedule?",
    [K.ADMIN_TABLE_RECORD]: "Record",
    [K.ADMIN_TABLE_RECORDS]: "records",
    [K.ADMIN_TABLE_MAINTENANCE_DATE]: "Maintenance Date",
    [K.ADMIN_TABLE_DURATION_MIN]: "Duration (min)",
    [K.ADMIN_TABLE_REPAIR_DURATION_MINUTES]: "Repair Duration (minutes)",
    [K.ADMIN_TABLE_ROOT_CAUSE]: "Root Cause",
    [K.ADMIN_TABLE_TECHNICIAN]: "Technician",
    [K.ADMIN_TABLE_COMPLETION_STATUSES]: "Completion Statuses",
    [K.ADMIN_TABLE_SELECT_TECHNICIAN_OPTIONAL]: "Select Technician (Optional)",
    [K.ADMIN_TABLE_SELECT_FAILURE_CATEGORY_OPTIONAL]: "Select Failure Category (Optional)",
    [K.ADMIN_TABLE_SELECT_COMPLETION_STATUS_OPTIONAL]: "Select Completion Status (Optional)",
    [K.ADMIN_TABLE_ADD_MAINTENANCE_RECORD]: "Add Maintenance Record",
    [K.ADMIN_TABLE_EDIT_MAINTENANCE_RECORD]: "Edit Maintenance Record",
    [K.ADMIN_TABLE_ADD_NEW_MAINTENANCE_RECORD]: "Add New Maintenance Record",
    [K.ADMIN_TABLE_SEARCH_ASSET_TECHNICIAN_ROOT_CAUSE]: "Search asset, technician, root cause",
    [K.ADMIN_TABLE_CONFIRM_DELETE_RECORD]: "Are you sure you want to delete this record?",
    [K.ADMIN_TABLE_PART]: "Part",
    [K.ADMIN_TABLE_PARTS]: "parts",
    [K.ADMIN_TABLE_PART_CODE]: "Part Code",
    [K.ADMIN_TABLE_PART_NAME]: "Part Name",
    [K.ADMIN_TABLE_MANUFACTURER]: "Manufacturer",
    [K.ADMIN_TABLE_MANUFACTURER_OPTIONAL]: "Manufacturer (Optional)",
    [K.ADMIN_TABLE_COMPATIBLE_MACHINE_TYPES]: "Compatible Machine Types (comma-separated)",
    [K.ADMIN_TABLE_STOCK]: "Stock",
    [K.ADMIN_TABLE_STOCK_QUANTITY]: "Stock Quantity",
    [K.ADMIN_TABLE_REORDER_LEVEL]: "Reorder Level",
    [K.ADMIN_TABLE_ADD_NEW_SPARE_PART]: "Add New Spare Part",
    [K.ADMIN_TABLE_EDIT_SPARE_PART]: "Edit Spare Part",
    [K.ADMIN_TABLE_SEARCH_CODE_NAME_MANUFACTURER]: "Search code, name, manufacturer",
    [K.ADMIN_TABLE_CONFIRM_DELETE_PART]: "Are you sure you want to delete this part?",
    [K.ADMIN_TABLE_FULL_NAME]: "Full Name",
    [K.ADMIN_TABLE_EMAIL]: "Email",
    [K.ADMIN_TABLE_ROLES]: "Roles",
    [K.ADMIN_TABLE_NO_ROLES]: "No roles",
    [K.ADMIN_TABLE_BUSINESS_CODES]: "Business Codes",
    [K.ADMIN_TABLE_LAST_LOGIN]: "Last Login",
    [K.ADMIN_TABLE_NEVER]: "Never",
    [K.ADMIN_TABLE_ROLE]: "Role",
    [K.ADMIN_TABLE_ASSIGN_ROLE]: "Assign Role",
    [K.ADMIN_TABLE_ASSIGN_ROLE_TO]: "Assign Role to {name}",
    [K.ADMIN_TABLE_REMOVE_ROLE]: "Remove role",
    [K.ADMIN_TABLE_CONFIRM_REMOVE_ROLE]: "Are you sure you want to remove the \"{role}\" role from this user?",
    [K.ADMIN_TABLE_ASSIGNED_SUCCESSFULLY]: "assigned successfully",
    [K.ADMIN_TABLE_REMOVED_SUCCESSFULLY]: "removed successfully",
    [K.ADMIN_TABLE_FAILED_ASSIGN_ROLE]: "Failed to assign role",
    [K.ADMIN_TABLE_FAILED_REMOVE_ROLE]: "Failed to remove role",
    [K.ADMIN_TABLE_EDIT_CODE]: "Edit code",
    [K.ADMIN_TABLE_UPDATE_CODE]: "Update Code",
    [K.ADMIN_TABLE_CODE_UPDATED_SUCCESSFULLY]: "Code updated successfully",
    [K.ADMIN_TABLE_FAILED_UPDATE_CODE]: "Failed to update code",
    [K.ADMIN_TABLE_ROLE_CODE]: "{role} Code",
    [K.ADMIN_TABLE_BUSINESS_CODE_OPTIONAL]: "Business Code (optional)",
    [K.ADMIN_TABLE_LEAVE_EMPTY_AUTO_GENERATION]: "Leave empty for auto-generation",
    [K.ADMIN_TABLE_AUTO_CODE_EXAMPLE]: "If empty, code will be auto-generated (e.g., STU-000001)",
    [K.ADMIN_TABLE_EDIT_ROLE_CODE_FOR]: "Edit {role} Code for {name}",
    [K.ADMIN_TABLE_STUDENT]: "Student",
    [K.ADMIN_TABLE_INSTRUCTOR]: "Instructor",
    [K.ADMIN_TABLE_PRODUCTION_MANAGER]: "Production Manager",
    [K.ADMIN_TABLE_STUDENT_ID]: "Student ID",
    [K.ADMIN_TABLE_STUDENT_CODE]: "Student Code",
    [K.ADMIN_TABLE_ASSET_ID]: "Asset ID",
    [K.ADMIN_TABLE_UNASSIGN]: "Unassign",
    [K.ADMIN_TABLE_CONFIRM_UNASSIGN_EQUIPMENT]: "Are you sure you want to unassign this equipment?",
    [K.ADMIN_TABLE_EQUIPMENT_UNASSIGNED_SUCCESSFULLY]: "Equipment unassigned successfully",
    [K.ADMIN_TABLE_FAILED_UNASSIGN_EQUIPMENT]: "Failed to unassign equipment",
    [K.ADMIN_TABLE_SEARCH_STUDENT_ID_ASSET_ID]: "Search student ID, asset ID",
    [K.ADMIN_TABLE_SEARCH_STUDENT_CODE_ASSET_CODE]: "Search student code, asset code",
    [K.ADMIN_TABLE_STUDENT_ID_REQUIRED]: "Student ID *",
    [K.ADMIN_TABLE_ENTER_STUDENT_ID]: "Enter student ID",
    [K.ADMIN_TABLE_SELECT_STUDENT]: "Select a student",
    [K.ADMIN_TABLE_ROOM_ASSET_ID_REQUIRED]: "Room Asset ID *",
    [K.ADMIN_TABLE_ENTER_ROOM_ASSET_ID]: "Enter room asset ID",
    [K.ADMIN_TABLE_SELECT_ROOM_ASSET]: "Select a room asset",
    [K.ADMIN_TABLE_CLASS_REQUIRED]: "Class *",
    [K.ADMIN_TABLE_SELECT_A_CLASS]: "Select a class",
    [K.ADMIN_TABLE_ASSIGNED_DATE_REQUIRED]: "Assigned Date *",
    [K.ADMIN_TABLE_SELECT_INSTRUCTOR_OPTIONAL]: "Select an instructor (optional)",
    [K.ADMIN_TABLE_SELECT_INSTRUCTOR_REQUIRED]: "Select an instructor",
    [K.ADMIN_TABLE_INSTRUCTOR_REQUIRED]: "Instructor is required.",
    [K.ADMIN_TABLE_CLASS_DAYS]: "Class Days",
    [K.ADMIN_TABLE_TIMEFRAME_START]: "Start Time",
    [K.ADMIN_TABLE_TIMEFRAME_END]: "End Time",
    [K.ADMIN_TABLE_INVALID_TIMEFRAME]: "Each schedule group must have a valid start and end time.",
    [K.ADMIN_TABLE_TOTAL_SCHEDULE_HOURS]: "Total scheduled hours",
    [K.ADMIN_TABLE_REQUIRED_COURSE_HOURS]: "Required course hours",
    [K.ADMIN_TABLE_SCHEDULE_HOURS_INSUFFICIENT]: "Total scheduled hours must be at least course hours.",
    [K.ADMIN_TABLE_SCHEDULE_GROUPS_OVERLAP]: "Schedule groups cannot overlap on the same day.",
    [K.ADMIN_TABLE_SELECT_AT_LEAST_ONE_DAY]: "Select at least one class day.",
    [K.ADMIN_TABLE_MON]: "Mon",
    [K.ADMIN_TABLE_TUE]: "Tue",
    [K.ADMIN_TABLE_WED]: "Wed",
    [K.ADMIN_TABLE_THU]: "Thu",
    [K.ADMIN_TABLE_FRI]: "Fri",
    [K.ADMIN_TABLE_SAT]: "Sat",
    [K.ADMIN_TABLE_SUN]: "Sun",
    [K.ADMIN_TABLE_CHECK_TABLE]: "Check Table",
    [K.ADMIN_TABLE_COMPLEX_TABLE]: "Complex Table",
    [K.ADMIN_TABLE_APPROVED]: "Approved",
    [K.ADMIN_TABLE_DISABLED]: "Disabled",
    [K.ADMIN_TABLE_ERROR]: "Error",
    [K.ADMIN_DASHBOARD_TRAINING_CALENDAR_EVENTS]: "Training Calendar Events",
    [K.ADMIN_DASHBOARD_NO_EVENTS_ON_DATE]: "No events on selected date.",
    [K.ADMIN_DASHBOARD_MAINTENANCE_CALENDAR_EVENTS]: "Maintenance Events on Selected Date",

    [K.ADMIN_DASHBOARD_LOAD_FAILED]: "Failed to load dashboard data.",
    [K.ADMIN_DASHBOARD_TOTAL_ASSETS]: "Total Assets",
    [K.ADMIN_DASHBOARD_ACTIVE_ASSIGNMENTS]: "Active Worker Assignments",
    [K.ADMIN_DASHBOARD_OVERDUE_MAINTENANCE]: "Overdue Maintenance",
    [K.ADMIN_DASHBOARD_LOW_STOCK_PARTS]: "Low Stock Parts",
    [K.ADMIN_DASHBOARD_ACTIVE_SESSIONS_TODAY]: "Active Sessions Today",
    [K.ADMIN_DASHBOARD_HANDOVERS_THIS_MONTH]: "Handovers This Month",
    [K.ADMIN_DASHBOARD_OPEN_INCIDENTS]: "Open Incidents",

    [K.DASH_ASSET_STATUS_TITLE]: "Assets by Status",
    [K.DASH_ASSET_STATUS_SUBTITLE]: "Current status breakdown",
    [K.DASH_ASSETS_BY_CATEGORY_TITLE]: "Assets by Category",
    [K.DASH_ASSETS_BY_CATEGORY_SUBTITLE]: "Asset portfolio composition",
    [K.DASH_MAINTENANCE_TREND_TITLE]: "Maintenance Records — Last 12 Months",
    [K.DASH_MAINTENANCE_TREND_SUBTITLE]: "Monthly maintenance activity trend",
    [K.DASH_USAGE_TITLE]: "Equipment Usage — Last 30 Days",
    [K.DASH_USAGE_SUBTITLE]: "Running vs. downtime in minutes",
    [K.DASH_UPCOMING_MAINTENANCE_TITLE]: "Upcoming Maintenance (Next 30 Days)",
    [K.DASH_UPCOMING_MAINTENANCE_SUBTITLE]: "Scheduled maintenance due soon",
    [K.DASH_LOW_STOCK_TITLE]: "Low-Stock Spare Parts",
    [K.DASH_LOW_STOCK_SUBTITLE]: "Parts at or below reorder level",
    [K.DASH_OVERDUE]: "Overdue",
    [K.DASH_UPCOMING]: "Upcoming",
    [K.DASH_OUT_OF_STOCK]: "Out of Stock",
    [K.DASH_LOW_STOCK]: "Low Stock",

    [K.ADMIN_TABLE_RECORDS]: "Records",
    [K.ADMIN_TABLE_RUNNING_MINUTES]: "Running",
    [K.ADMIN_TABLE_DOWNTIME_MINUTES]: "Downtime",
    [K.ADMIN_TABLE_NEXT_DUE]: "Next Due",
    [K.ADMIN_TABLE_PART_CODE]: "Part Code",
    [K.ADMIN_TABLE_PART_NAME]: "Part Name",
    [K.ADMIN_TABLE_STOCK]: "Stock",
    [K.ADMIN_TABLE_REORDER_LEVEL]: "Reorder Level",

    [K.AUTH_BACK_TO_DASHBOARD]: "Back to Dashboard",
    [K.FOOTER_COPYRIGHT]: "©{year} University of Economics - Technology for Industries.",

    [K.PORTAL_ACCESS_TITLE]: "Portal Access Management",
    [K.PORTAL_ACCESS_DESCRIPTION]: "Grant or revoke portal access by linking UserProfiles to Student / Instructor / Technician domain roles.",
    [K.PORTAL_ACCESS_GRANT_SELECTED]: "Grant Selected ({count})",
    [K.PORTAL_ACCESS_REVOKE_SELECTED]: "Revoke Selected ({count})",
    [K.PORTAL_ACCESS_GRANT]: "Grant",
    [K.PORTAL_ACCESS_REVOKE]: "Revoke",
    [K.PORTAL_ACCESS_NO_USERS]: "No users found",
    [K.PORTAL_ACCESS_SELECT_USER]: "Please select at least one user.",
    [K.PORTAL_ACCESS_ALREADY_GRANTED]: "All selected users already have {portal} access.",
    [K.PORTAL_ACCESS_NONE_TO_REVOKE]: "None of the selected users currently have {portal} access.",
    [K.PORTAL_ACCESS_CONFIRM_GRANT]: "Grant {portal} for {count} user(s)?",
    [K.PORTAL_ACCESS_CONFIRM_REVOKE_BULK]: "Revoke {portal} for {count} user(s)?",
    [K.PORTAL_ACCESS_GRANTED]: "Granted {portal} for {count} user(s).",
    [K.PORTAL_ACCESS_REVOKED]: "Revoked {portal} for {count} user(s).",
    [K.PORTAL_ACCESS_PARTIAL_GRANT]: "Granted {portal} for {count} user(s). {failed} user(s) failed. Check console for details.",
    [K.PORTAL_ACCESS_PARTIAL_REVOKE]: "Revoked {portal} for {count} user(s). {failed} user(s) failed. Check console for details.",
    [K.PORTAL_ACCESS_GRANT_SUCCESS]: "Granted {portal} successfully.",
    [K.PORTAL_ACCESS_REVOKE_SUCCESS]: "Revoked {portal} successfully.",
    [K.PORTAL_ACCESS_CONFIRM_SINGLE_REVOKE]: "Revoke {portal} for {name}?",
    [K.PORTAL_ACCESS_GRANT_FAILED]: "Grant failed: {error}",
    [K.PORTAL_ACCESS_REVOKE_FAILED]: "Revoke failed: {error}",
    [K.PORTAL_ACCESS_BULK_FAILED]: "Bulk operation failed: {error}",
    [K.PORTAL_ACCESS_FETCH_FAILED]: "Failed to fetch users: {error}",
    [K.PORTAL_ACCESS_REVOKE_BLOCKED_ACTIVE_ASSET]: "User has active asset assigned, please unassign before revoking.",
    [K.PORTAL_ACCESS_REVOKE_BLOCKED_ACTIVE_ASSET_WITH_PORTAL]: "User has active asset assigned, please unassign before revoking {portal} access.",
    [K.PORTAL_ACCESS_REVOKE_BLOCKED_SELECTED_ACTIVE_ASSETS]: "Some selected users have active asset assignments. Please unassign before revoking portal access.",
    [K.PORTAL_ACCESS_REVOKE_BLOCKED_SELECTED_TOOLTIP]: "Some selected users have active asset assignments and cannot be revoked until unassigned.",

    [K.CONFIG_CATEGORIES_HEADING]: "Categories",
    [K.CONFIG_ADD_CATEGORY]: "Add category",
    [K.CONFIG_ITEM_COUNT]: "({count} items)",
    [K.CONFIG_SELECT_A_CATEGORY]: "Select a category",
    [K.CONFIG_CATEGORY_ITEMS_HEADER]: "{name} Items",
    [K.CONFIG_ADD_ITEM]: "Add Item",
    [K.CONFIG_NO_ITEMS]: "No items in this category.",
    [K.CONFIG_LABEL_LANGUAGE]: "Label ({language})",
    [K.CONFIG_SORT_ORDER]: "Sort Order",
    [K.CONFIG_EDIT_TRANSLATIONS_TITLE]: "Edit translations",
    [K.CONFIG_NEW_CATEGORY]: "New Category",
    [K.CONFIG_CATEGORY_CODE_PLACEHOLDER]: "Category Code (e.g. AssetCondition)",
    [K.CONFIG_DESCRIPTION_OPTIONAL]: "Description (optional)",
    [K.CONFIG_NEW_ITEM]: "New Configuration Item",
    [K.CONFIG_EDIT_TRANSLATIONS_MODAL]: "Edit Translations",
    [K.CONFIG_ITEM_CODE_PLACEHOLDER]: "Item Code (e.g. PAIR)",
    [K.CONFIG_TRANSLATIONS_LABEL]: "Translations",
    [K.CONFIG_LABEL_IN_LANGUAGE]: "Label in {languageName}",
    [K.CONFIG_CONFIRM_DELETE_ITEM]: "Are you sure you want to delete this configuration item?",
    [K.CONFIG_CATEGORY_CREATED]: "Category created successfully",
    [K.CONFIG_CREATE_CATEGORY_FAILED]: "Failed to create category: {error}",
    [K.CONFIG_TRANSLATIONS_UPDATED]: "Translations updated successfully",
    [K.CONFIG_ITEM_CREATED]: "Item created successfully",
    [K.CONFIG_SAVE_ITEM_FAILED]: "Failed to save item: {error}",
    [K.CONFIG_ITEM_DELETED]: "Item deleted",
    [K.CONFIG_DELETE_ITEM_FAILED]: "Failed to delete item: {error}",
    [K.CONFIG_FETCH_CATEGORIES_FAILED]: "Failed to fetch categories: {error}",
    [K.NAV_NO_NOTIFICATIONS]: "You have no notifications",
    [K.NAV_NOTIFICATIONS_LOADING]: "Loading notifications...",
    [K.NAV_NOTIFICATIONS_ERROR]: "Could not load notifications",
    [K.NAV_NOTIFICATIONS_UNREAD]: "{count} unread",
  },
  "vi-VN": {
    [K.APP_NAME_SHORT]: "Tài sản",
    [K.APP_NAME_FULL]: "Quản lý tài sản",
    [K.NAV_SEARCH_PLACEHOLDER]: "Tìm kiếm trang...",
    [K.NAV_OPEN_NAVIGATION]: "Mở điều hướng",
    [K.NAV_SEARCH]: "Tìm kiếm",
    [K.NAV_CLOSE_SEARCH]: "Đóng tìm kiếm",
    [K.NAV_SELECT_LANGUAGE]: "Chọn ngôn ngữ",
    [K.NAV_NOTIFICATION]: "Thông báo",
    [K.NAV_MARK_ALL_READ]: "Đánh dấu tất cả đã đọc",
    [K.NAV_MARK_ALL_AS_READ]: "Đánh dấu tất cả đã đọc",
    [K.NAV_SHOW_ALL]: "Xem tất cả",
    [K.NAV_DISMISS_NOTIFICATION]: "Ẩn thông báo",
    [K.NAV_JUST_NOW]: "vừa xong",
    [K.NAV_MINS_AGO]: "{count} phút trước",
    [K.NAV_HOURS_AGO]: "{count} giờ trước",
    [K.PILL_VIEW_DETAILS]: "Xem chi tiết",
    [K.PILL_EDIT]: "Chỉnh sửa",
    [K.PILL_LOADING]: "Đang tải...",
    [K.PILL_LOAD_ERROR]: "Không thể tải chi tiết",
    [K.PILL_ASSET_DETAILS]: "Chi tiết thiết bị",
    [K.PILL_CLASS_DETAILS]: "Chi tiết lớp học",
    [K.PILL_STUDENT_DETAILS]: "Chi tiết học viên",
    [K.PILL_FIELD_CODE]: "Mã",
    [K.PILL_FIELD_NAME]: "Tên",
    [K.PILL_FIELD_CATEGORY]: "Danh mục",
    [K.PILL_FIELD_BRAND]: "Hãng",
    [K.PILL_FIELD_MODEL]: "Model",
    [K.PILL_FIELD_STATUS]: "Trạng thái",
    [K.PILL_FIELD_COURSE]: "Khóa học",
    [K.PILL_FIELD_INSTRUCTOR]: "Giảng viên",
    [K.PILL_FIELD_ROOM]: "Phòng",
    [K.PILL_FIELD_START_DATE]: "Ngày bắt đầu",
    [K.PILL_FIELD_END_DATE]: "Ngày kết thúc",
    [K.PILL_FIELD_STUDENT_CODE]: "Mã học viên",
    [K.PILL_FIELD_FULL_NAME]: "Họ và tên",
    [K.PILL_FIELD_ASSIGNED_DATE]: "Ngày phân công",
    [K.NAV_PROFILE_SETTINGS]: "Hồ sơ",
    [K.NAV_GO_HOME]: "Về trang chủ",
    [K.NAV_LOG_OUT]: "Đăng xuất",
    [K.NAV_PORTAL]: "Cổng",

    [K.MENU_GROUP_ASSET_MANAGEMENT]: "Quản lý tài sản",
    [K.MENU_GROUP_PRODUCTION_WORKERS]: "Sản xuất & Công nhân",
    [K.MENU_GROUP_TRAINING]: "Chế độ đào tạo",
    [K.MENU_GROUP_MAINTENANCE]: "Bảo trì",
    [K.MENU_GROUP_ADMINISTRATION]: "Quản trị",

    [K.ROUTE_DASHBOARD]: "Tổng quan",
    [K.ROUTE_ASSETS]: "Tài sản",
    [K.ROUTE_CATEGORIES]: "Danh mục",
    [K.ROUTE_DEPARTMENTS]: "Phòng ban",
    [K.ROUTE_ROOMS]: "Phòng học",
    [K.ROUTE_HANDOVERS]: "Bàn giao",
    [K.ROUTE_CONFIGURATION]: "Cấu hình",
    [K.ROUTE_USERS]: "Người dùng",
    [K.ROUTE_PORTAL_ACCESS]: "Truy cập cổng",
    [K.ROUTE_PRODUCTION_LINES]: "Chuyền sản xuất",
    [K.ROUTE_PRODUCTION_ORDERS]: "Lệnh sản xuất",
    [K.ROUTE_PRODUCTION_STEPS]: "Công đoạn sản xuất",
    [K.ROUTE_WORKER_EQUIPMENT]: "Thiết bị công nhân",
    [K.ROUTE_EQUIPMENT_USAGE]: "Sử dụng thiết bị",
    [K.ROUTE_WORKING_TIME]: "Lịch làm việc",
    [K.ROUTE_COURSES]: "Khóa học",
    [K.ROUTE_CLASSES]: "Lớp học",
    [K.ROUTE_STUDENT_ASSIGNMENTS]: "Phân bổ học viên",
    [K.ROUTE_ASSET_MAPPINGS]: "Ánh xạ tài sản",
    [K.ROUTE_MAINTENANCE_SCHEDULES]: "Lịch bảo trì",
    [K.ROUTE_MAINTENANCE_RECORDS]: "Phiếu bảo trì",
    [K.ROUTE_SPARE_PARTS]: "Linh kiện",
    [K.ROUTE_SPARE_ASSETS]: "Tài sản dự phòng",
    [K.ROUTE_ASSET_ITEMS]: "Tất cả vật tư",
    [K.ROUTE_SIGN_IN]: "Đăng nhập",

    [K.PORTAL_ADMIN_NAME]: "Cổng quản trị",
    [K.PORTAL_STUDENT_NAME]: "Cổng học viên",
    [K.PORTAL_TEACHER_NAME]: "Cổng giảng viên",
    [K.PORTAL_MAINTAINER_NAME]: "Cổng kỹ thuật viên",
    [K.PORTAL_WORKER_NAME]: "Cổng công nhân",
    [K.PORTAL_PRODUCTION_MANAGER_NAME]: "Cổng quản lý sản xuất",

    [K.WORKER_PORTAL_TITLE]: "Cổng công nhân",
    [K.WORKER_MY_PRODUCTION_LINE]: "Dây chuyền của tôi",
    [K.WORKER_EMPLOYEE_CODE]: "Mã nhân viên",
    [K.WORKER_MY_EQUIPMENT]: "Thiết bị của tôi",
    [K.WORKER_NO_EQUIPMENT]: "Hiện chưa có thiết bị nào được giao cho bạn.",
    [K.WORKER_ASSIGNED_SINCE]: "Được giao từ",
    [K.WORKER_ACTIVE_SESSION]: "Phiên đang hoạt động",
    [K.WORKER_NO_ACTIVE_SESSION]: "Không có phiên nào đang hoạt động. Bắt đầu phiên bên dưới.",
    [K.WORKER_START_SESSION]: "Bắt đầu phiên",
    [K.WORKER_END_SESSION]: "Kết thúc phiên",
    [K.WORKER_LOG_SESSION]: "Ghi nhận phiên",
    [K.WORKER_SELECT_EQUIPMENT]: "Chọn thiết bị",
    [K.WORKER_START_TIME]: "Thời gian bắt đầu",
    [K.WORKER_END_TIME]: "Thời gian kết thúc",
    [K.WORKER_RUNNING_MINUTES]: "Số phút vận hành",
    [K.WORKER_DOWNTIME_MINUTES]: "Số phút dừng máy",
    [K.WORKER_STITCH_COUNT]: "Số mũi may",
    [K.WORKER_NOTES]: "Ghi chú",
    [K.WORKER_USAGE_HISTORY]: "Lịch sử sử dụng",
    [K.WORKER_NO_USAGE_HISTORY]: "Chưa có lịch sử sử dụng.",
    [K.WORKER_SESSION_STARTED]: "Đã bắt đầu phiên thành công.",
    [K.WORKER_SESSION_ENDED]: "Đã kết thúc phiên thành công.",
    [K.WORKER_SESSION_START_FAILED]: "Không thể bắt đầu phiên.",
    [K.WORKER_SESSION_END_FAILED]: "Không thể kết thúc phiên.",
    [K.WORKER_LOADING]: "Đang tải dữ liệu của bạn...",
    [K.WORKER_LOAD_FAILED]: "Không thể tải dữ liệu công nhân.",
    [K.WORKER_ELAPSED]: "Đã trôi qua",
    [K.WORKER_NO_LINE]: "Chưa được phân công dây chuyền",
    [K.WORKER_WORKING_CALENDAR]: "Lịch làm việc",
    [K.WORKER_NO_WORK_EVENTS]: "Không có ca làm việc trong ngày đã chọn.",
    [K.WORKER_QR_ATTENDANCE]: "Điểm danh QR",
    [K.WORKER_QR_CHECKIN]: "Bắt đầu điểm danh",
    [K.WORKER_QR_CHECKOUT]: "Kết thúc điểm danh",
    [K.WORKER_QR_INPUT_PLACEHOLDER]: "Nhập hoặc quét mã QR",
    [K.WORKER_QR_CHECKIN_SUCCESS]: "Bắt đầu điểm danh thành công.",
    [K.WORKER_QR_CHECKOUT_SUCCESS]: "Kết thúc điểm danh thành công.",
    [K.WORKER_QR_ACTION_FAILED]: "Thao tác điểm danh QR thất bại",
    [K.WORKER_OPEN_CAMERA]: "Mở camera",
    [K.WORKER_CLOSE_CAMERA]: "Tắt camera",
    [K.WORKER_CAMERA_UNSUPPORTED]: "Trình duyệt này không hỗ trợ quét QR bằng camera.",
    [K.WORKER_CAMERA_START_FAILED]: "Không thể khởi động camera",
    [K.WORKER_QR_SCANNING]: "Đang quét...",
    [K.WORKER_SHIFT_LABEL]: "Ca làm",
    [K.WORKER_QR_SCAN_CHECKIN_HINT]: "Quét mã QR để bắt đầu điểm danh ca làm này.",
    [K.WORKER_QR_SCAN_CHECKOUT_HINT]: "Quét mã QR để kết thúc điểm danh ca làm này.",

    [K.ADMIN_WORKING_TIME_GLOBAL_TITLE]: "Cấu hình giờ làm việc chung",
    [K.ADMIN_WORKING_TIME_OVERRIDE_TITLE]: "Ghi đè theo công nhân",
    [K.ADMIN_WORKING_TIME_TIMEZONE]: "Múi giờ",
    [K.ADMIN_WORKING_TIME_TIMEZONE_OPTIONAL]: "Múi giờ (tùy chọn)",
    [K.ADMIN_WORKING_TIME_CHECKIN_BEFORE]: "Bắt đầu điểm danh trước (phút)",
    [K.ADMIN_WORKING_TIME_CHECKIN_AFTER]: "Bắt đầu điểm danh sau (phút)",
    [K.ADMIN_WORKING_TIME_CHECKOUT_BEFORE]: "Kết thúc điểm danh trước (phút)",
    [K.ADMIN_WORKING_TIME_CHECKOUT_AFTER]: "Kết thúc điểm danh sau (phút)",
    [K.ADMIN_WORKING_TIME_SAVE_GLOBAL]: "Lưu cấu hình chung",
    [K.ADMIN_WORKING_TIME_SAVE_OVERRIDE]: "Lưu ghi đè",
    [K.ADMIN_WORKING_TIME_GLOBAL_SAVED]: "Đã lưu cấu hình giờ làm việc chung.",
    [K.ADMIN_WORKING_TIME_OVERRIDE_SAVED]: "Đã lưu ghi đè công nhân.",
    [K.ADMIN_WORKING_TIME_OVERRIDE_DELETED]: "Đã xóa ghi đè.",
    [K.ADMIN_WORKING_TIME_NO_OVERRIDES]: "Chưa có ghi đè công nhân.",
    [K.ADMIN_WORKING_TIME_LOAD_FAILED]: "Không thể tải cấu hình giờ làm việc.",
    [K.ADMIN_WORKING_TIME_SAVE_FAILED]: "Không thể lưu cấu hình giờ làm việc.",
    [K.ADMIN_WORKING_TIME_DELETE_FAILED]: "Không thể xóa ghi đè.",
    [K.ADMIN_WORKING_TIME_DELETE_CONFIRM]: "Xóa ghi đè này?",
    [K.ADMIN_WORKING_TIME_OVERRIDE_REQUIRED]: "Vui lòng chọn công nhân và khoảng ngày.",
    [K.ADMIN_WORKING_TIME_SHIFT_NAME]: "Tên Ca Làm",
    [K.ADMIN_WORKING_TIME_SHIFT_NAME_PH]: "VD: Ca Sáng",
    [K.ADMIN_WORKING_TIME_ADD_SHIFT]: "Thêm Ca",
    [K.ADMIN_WORKING_TIME_REMOVE_SHIFT]: "Xóa",
    [K.ADMIN_WORKING_TIME_WINDOWS_TITLE]: "Cửa Sổ Bắt Đầu / Kết Thúc Điểm Danh",
    [K.ADMIN_WORKING_TIME_SHIFTS_TITLE]: "Ca Làm Việc Toàn Cục",
    [K.ADMIN_WORKING_TIME_WORKERS_TITLE]: "Phân Ca Công Nhân",
    [K.ADMIN_WORKING_TIME_ASSIGN_WORKER]: "Phân Ca Cho Công Nhân",
    [K.ADMIN_WORKING_TIME_EDIT_OVERRIDE]: "Chỉnh Sửa Ghi Đè",
    [K.ADMIN_WORKING_TIME_INHERITS_GLOBAL]: "Kế thừa lịch toàn cục",
    [K.ADMIN_WORKING_TIME_DAYS]: "Ngày Làm Việc",
    [K.ADMIN_WORKING_TIME_START_TIME]: "Giờ Bắt Đầu",
    [K.ADMIN_WORKING_TIME_END_TIME]: "Giờ Kết Thúc",
    [K.ADMIN_WORKING_TIME_WORKER_COL]: "Công Nhân",
    [K.ADMIN_WORKING_TIME_DATE_RANGE_COL]: "Khoảng Ngày",
    [K.ADMIN_WORKING_TIME_CANCEL]: "Hủy",
    [K.ADMIN_WORKING_TIME_ACTIVE_OVERRIDE]: "Ghi Đè Đang Hoạt Động",
    [K.ADMIN_WORKING_TIME_EXCLUDE_GLOBAL_SHIFTS]: "Khi kế thừa lịch toàn cục, bỏ áp dụng các ca đã chọn",
    [K.ADMIN_WORKING_TIME_EXCLUDED_SHIFTS]: "Đã loại trừ",

    [K.PAGE_PROFILE]: "Hồ sơ",
    [K.PROFILE_ASSIGNED_PORTALS]: "Quyền truy cập cổng đã được cấp",
    [K.PROFILE_NO_PORTAL_ACCESS]: "Chưa được cấp quyền truy cập cổng",
    [K.PROFILE_NOTIFICATION_HISTORY]: "Lịch sử thông báo",
    [K.PROFILE_NEWEST_FIRST]: "Mới nhất đến cũ nhất",
    [K.PROFILE_LOADING_NOTIFICATIONS]: "Đang tải thông báo...",
    [K.PROFILE_FAILED_NOTIFICATIONS]: "Không thể tải thông báo",
    [K.PROFILE_NOTIFICATION_EMPTY]: "Không có thông báo",
    [K.PROFILE_READ]: "Đã đọc",
    [K.PROFILE_UNREAD]: "Chưa đọc",
    [K.PROFILE_PAGE_INFO]: "Trang {page} / {totalPages}",
    [K.PROFILE_PREVIOUS]: "Trước",
    [K.PROFILE_NEXT]: "Sau",
    [K.PROFILE_TIMEZONE_SETTINGS]: "Cài đặt múi giờ",
    [K.PROFILE_TIMEZONE_LABEL]: "Múi giờ của bạn",
    [K.PROFILE_TIMEZONE_PLACEHOLDER]: "Chọn múi giờ...",
    [K.PROFILE_TIMEZONE_SAVE]: "Lưu múi giờ",
    [K.PROFILE_TIMEZONE_SAVING]: "Đang lưu...",
    [K.PROFILE_TIMEZONE_SAVED]: "Đã lưu múi giờ!",
    [K.PROFILE_TIMEZONE_ERROR]: "Không thể lưu múi giờ",
    [K.PAGE_NO_PORTAL_ACCESS_TITLE]: "Cần cấp quyền truy cập cổng",
    [K.PAGE_NO_PORTAL_ACCESS_BODY_1]: "Tài khoản của bạn đã kích hoạt, nhưng chưa được cấp quyền vào cổng nào.",
    [K.PAGE_NO_PORTAL_ACCESS_BODY_2]: "Vui lòng liên hệ quản trị viên để cấp quyền vào cổng Học viên, Giảng viên, Bảo trì, Công nhân hoặc Quản trị.",
    [K.PAGE_SIGN_OUT]: "Đăng xuất",

    [K.STUDENT_PORTAL_TITLE]: "Cổng học viên",
    [K.TEACHER_PORTAL_TITLE]: "Cổng giảng viên",
    [K.MAINTAINER_PORTAL_TITLE]: "Cổng kỹ thuật viên",

    [K.COMMON_DAILY_DETAILS]: "Chi tiết trong ngày",
    [K.CALENDAR_TODAY]: "Hôm nay",
    [K.CALENDAR_PREVIOUS_DAY]: "Ngày trước",
    [K.CALENDAR_NEXT_DAY]: "Ngày tiếp theo",
    [K.CALENDAR_NO_EVENTS_FOR_DAY]: "Không có sự kiện nào trong ngày này.",
    [K.CALENDAR_BADGE_CLASS]: "Lớp",
    [K.CALENDAR_BADGE_ASSIGNMENT]: "Phân công",
    [K.CALENDAR_BADGE_SESSION]: "Phiên",
    [K.CALENDAR_BADGE_INCIDENT]: "Sự cố",
    [K.CALENDAR_SHOW_STUDENTS]: "Hiện học viên",
    [K.CALENDAR_HIDE_STUDENTS]: "Ẩn học viên",

    [K.TABLE_NO_DATA]: "Không có dữ liệu",
    [K.TABLE_ITEMS]: "mục",
    [K.TABLE_DELETE_SELECTED]: "Xóa đã chọn",
    [K.TABLE_ROWS]: "Số dòng",
    [K.TABLE_PAGE]: "Trang",
    [K.TABLE_PREV]: "Trước",
    [K.TABLE_NEXT]: "Sau",
    [K.TABLE_CONFIRM_DELETE_SELECTED]: "Bạn có chắc muốn xóa các mục đã chọn?",
    [K.TABLE_BULK_DELETE_FAILED]: "Xóa hàng loạt thất bại",
    [K.MODAL_CLOSE]: "Đóng",

    [K.SIGNIN_WELCOME_BACK]: "Chào mừng bạn quay lại",
    [K.SIGNIN_MICROSOFT_PROMPT]: "Đăng nhập bằng tài khoản Microsoft",
    [K.SIGNIN_PREPARING]: "Đang chuẩn bị đăng nhập...",
    [K.SIGNIN_WITH_MICROSOFT]: "Đăng nhập với Microsoft",
    [K.SIGNIN_ORG_ACCOUNT_HINT]: "Sử dụng tài khoản Microsoft tổ chức của bạn",
    [K.SIGNIN_ERR_SECURE_BROWSER]: "Trình duyệt này không thể tạo yêu cầu đăng nhập PKCE an toàn. Hãy mở trang bằng Chrome/Safari (không dùng trình duyệt trong ứng dụng) và đảm bảo HTTPS.",
    [K.SIGNIN_ERR_UNKNOWN]: "Lỗi đăng nhập không xác định",
    [K.SIGNIN_ERR_IN_PROGRESS]: "Đăng nhập đang được xử lý. Vui lòng chờ vài giây rồi thử lại.",
    [K.SIGNIN_ERR_PKCE]: "Không tạo được PKCE trên trình duyệt di động này. Hãy mở ứng dụng bằng Chrome/Safari (ngoài in-app browser) rồi thử lại.",
    [K.SIGNIN_ERR_UNABLE_START]: "Không thể bắt đầu đăng nhập Microsoft ({errorCode}). Hãy thử mở bằng Chrome/Safari và đăng nhập lại.",

    [K.STUDENT_MY_ACTIVE_ASSETS]: "Tài sản đang hoạt động của tôi",
    [K.STUDENT_READY_FOR_ATTENDANCE]: "Sẵn sàng bắt đầu điểm danh",
    [K.STUDENT_OPEN_SESSIONS]: "Phiên đang mở",
    [K.STUDENT_CHECKOUT_TO_COMPLETE]: "Kết thúc điểm danh để hoàn tất điểm danh",
    [K.STUDENT_TOTAL_SESSIONS]: "Tổng số phiên",
    [K.STUDENT_PRACTICE_HISTORY]: "Lịch sử hoạt động thực hành",
    [K.STUDENT_LOAD_FAILED]: "Tải cổng học viên thất bại",
    [K.STUDENT_SCANNER_UNSUPPORTED]: "Trình duyệt này không hỗ trợ quét QR bằng camera.",
    [K.STUDENT_QR_DETECTED]: "Đã nhận diện QR. Sẵn sàng gửi.",
    [K.STUDENT_SCANNER_START_FAILED]: "Không thể khởi động camera quét",
    [K.STUDENT_ENTER_QR_FIRST]: "Vui lòng quét hoặc nhập mã QR trước.",
    [K.STUDENT_QR_CHECKOUT_SUCCESS]: "Bắt đầu điểm danh thành công.",
    [K.STUDENT_QR_CHECKOUT_FAILED]: "Bắt đầu điểm danh thất bại",
    [K.STUDENT_QR_CHECKIN_SUCCESS]: "Kết thúc điểm danh thành công.",
    [K.STUDENT_QR_CHECKIN_FAILED]: "Kết thúc điểm danh thất bại",
    [K.STUDENT_SELECT_ASSIGNMENT_FIRST]: "Vui lòng chọn phân công để bắt đầu điểm danh.",
    [K.STUDENT_CHECKIN_SUCCESS]: "Bắt đầu điểm danh thành công.",
    [K.STUDENT_CHECKIN_FAILED]: "Bắt đầu điểm danh thất bại",
    [K.STUDENT_CHECKOUT_SUCCESS]: "Kết thúc điểm danh thành công.",
    [K.STUDENT_CHECKOUT_FAILED]: "Kết thúc điểm danh thất bại",
    [K.STUDENT_ISSUE_REPORTED]: "Báo lỗi thành công.",
    [K.STUDENT_ISSUE_REPORT_FAILED]: "Báo lỗi thất bại",
    [K.STUDENT_QR_SECTION_TITLE]: "Bắt đầu điểm danh / Kết thúc điểm danh",
    [K.STUDENT_QR_SECTION_HINT]: "Quét bằng camera hoặc nhập QR thủ công để bắt đầu hoặc kết thúc điểm danh.",
    [K.STUDENT_QR_CODE_VALUE]: "Giá trị mã QR",
    [K.STUDENT_QR_CHECKOUT_BUTTON]: "Bắt đầu điểm danh",
    [K.STUDENT_QR_CHECKIN_BUTTON]: "Kết thúc điểm danh",
    [K.STUDENT_STOP_CAMERA]: "Dừng camera",
    [K.STUDENT_START_CAMERA]: "Bật camera",
    [K.STUDENT_QR_SCAN_CHECKOUT_HINT]: "Quét mã QR của tài sản để bắt đầu điểm danh tự động.",
    [K.STUDENT_QR_SCAN_CHECKIN_HINT]: "Quét mã QR của tài sản để kết thúc điểm danh tự động.",
    [K.STUDENT_ATTENDANCE_CHECKIN_TITLE]: "Bắt đầu điểm danh",
    [K.STUDENT_ATTENDANCE_CHECKIN_HINT]: "Chọn tài sản được phân công và bắt đầu phiên.",
    [K.STUDENT_SELECT_ASSIGNMENT]: "Chọn phân công",
    [K.STUDENT_ASSIGNMENT_ROW]: "Phân công",
    [K.STUDENT_CHECKIN_BUTTON]: "Bắt đầu điểm danh",
    [K.STUDENT_REPORT_ISSUE_TITLE]: "Báo sự cố",
    [K.STUDENT_REPORT_ISSUE_HINT]: "Chia sẻ mọi sự cố thiết bị trong phiên hiện tại.",
    [K.STUDENT_SELECT_SESSION]: "Chọn phiên",
    [K.STUDENT_SESSION_ROW]: "Phiên",
    [K.STUDENT_DESCRIBE_EVENT]: "Mô tả sự việc đã xảy ra",
    [K.STUDENT_SUBMIT_ISSUE]: "Gửi báo lỗi",
    [K.STUDENT_ACTIVE_QR_CHECKOUTS]: "Điểm danh đang diễn ra của tôi",
    [K.STUDENT_NO_ACTIVE_QR_CHECKOUTS]: "Không có điểm danh nào đang diễn ra.",
    [K.STUDENT_QR_CHECKOUT_INFO]: "Bắt đầu lúc",
    [K.STUDENT_ASSETS_AND_SESSIONS]: "Tài sản và phiên của tôi",
    [K.STUDENT_MY_ASSIGNED_ASSETS]: "Tài sản được phân công của tôi",
    [K.STUDENT_NO_ASSETS_OR_SESSIONS]: "Không có tài sản được phân công hoặc phiên đang hoạt động.",
    [K.STUDENT_NO_ASSIGNMENTS]: "Chưa có phân công.",
    [K.STUDENT_ACTIVE]: "Đang hoạt động",
    [K.STUDENT_SESSION_OPEN]: "Phiên đang mở",
    [K.STUDENT_UNASSIGNED]: "Chưa phân công",
    [K.STUDENT_ASSIGNED_INFO]: "Được phân công",
    [K.STUDENT_NO_OPEN_SESSION]: "Không có phiên đang hoạt động trên tài sản này.",
    [K.STUDENT_NO_ACTIVE_CHECKINS]: "Không có điểm danh nào đang diễn ra.",
    [K.STUDENT_SESSION_INFO]: "Bắt đầu",
    [K.STUDENT_CHECKOUT_BUTTON]: "Kết thúc điểm danh",
    [K.STUDENT_ATTENDANCE_STATUS]: "Điểm danh",
    [K.STUDENT_CLASS_START]: "Lớp bắt đầu",
    [K.STUDENT_CLASS_END]: "Lớp kết thúc",
    [K.STUDENT_LOAD_COURSE_CLASSES_FAILED]: "Tải danh sách lớp theo khóa học thất bại",
    [K.STUDENT_SELECT_CLASS]: "Chọn lớp",
    [K.STUDENT_SELECT_CLASS_TO_ENROLL]: "Vui lòng chọn lớp để đăng ký.",
    [K.STUDENT_ENROLL_SUCCESS]: "Đăng ký lớp thành công.",
    [K.STUDENT_ENROLL_FAILED]: "Đăng ký lớp thất bại",
    [K.STUDENT_CANCEL_ENROLLMENT_SUCCESS]: "Hủy đăng ký lớp thành công.",
    [K.STUDENT_CANCEL_ENROLLMENT_FAILED]: "Hủy đăng ký lớp thất bại",
    [K.STUDENT_ENROLL_CLASS_TITLE]: "Tìm lớp và đăng ký",
    [K.STUDENT_ENROLL_CLASS_HINT]: "Chọn khóa học, xem các lớp và đăng ký vào lớp phù hợp.",
    [K.STUDENT_CURRENT_CLASS]: "Lớp hiện tại",
    [K.STUDENT_CURRENT_CLASS_BADGE]: "Đã đăng ký",
    [K.STUDENT_NOT_ENROLLED]: "Bạn chưa đăng ký lớp nào.",
    [K.STUDENT_SELECT_COURSE]: "Chọn khóa học",
    [K.STUDENT_SELECT_COURSE_TO_VIEW_CLASSES]: "Chọn khóa học để xem các lớp hiện có.",
    [K.STUDENT_NO_CLASSES_FOR_COURSE]: "Không có lớp khả dụng cho khóa học này.",
    [K.STUDENT_ENROLL_BUTTON]: "Đăng ký lớp",
    [K.STUDENT_WITHDRAW_ENROLLMENT_BUTTON]: "Rút đăng ký lớp",
    [K.STUDENT_ENROLLMENT_CANCELLATION_CLOSED]: "Đã quá thời hạn rút đăng ký lớp này.",
    [K.STUDENT_ONE_CLASS_ONLY_HINT]: "Bạn đã đăng ký một lớp. Hãy rút đăng ký hiện tại trước khi đăng ký lớp khác.",
    [K.STUDENT_CLASS_CODE]: "Mã lớp",
    [K.STUDENT_CLASS_TEACHER]: "Giảng viên",
    [K.STUDENT_CLASS_ROOM]: "Phòng",
    [K.STUDENT_CLASS_DATE_RANGE]: "Thời gian",
    [K.STUDENT_CLASS_AVAILABLE_SLOTS]: "Chỗ trống",
    [K.STUDENT_CLASS_UNLIMITED_SLOTS]: "Không giới hạn",
    [K.STUDENT_CLASS_SCHEDULE]: "Lịch học",
    [K.STUDENT_TRAINING_CALENDAR]: "Lịch đào tạo",
    [K.STUDENT_NO_EVENTS_ON_DATE]: "Không có sự kiện đào tạo trong ngày đã chọn.",

    [K.TEACHER_LOAD_FAILED]: "Tải không gian làm việc giảng viên thất bại",
    [K.TEACHER_ASSIGN_SUCCESS]: "Phân công tài sản thành công.",
    [K.TEACHER_ASSIGN_FAILED]: "Phân công thất bại",
    [K.TEACHER_FORCE_RETURN_REASON]: "Nhập lý do thu hồi bắt buộc:",
    [K.TEACHER_FORCE_RETURN_DEFAULT_REASON]: "Được thu hồi bởi giảng viên/quản trị",
    [K.TEACHER_FORCE_RETURN_SUCCESS]: "Đã thu hồi tài sản bắt buộc.",
    [K.TEACHER_FORCE_RETURN_FAILED]: "Thu hồi bắt buộc thất bại",
    [K.TEACHER_ISSUE_REPORTED]: "Báo lỗi thành công.",
    [K.TEACHER_ISSUE_REPORT_FAILED]: "Báo lỗi thất bại",
    [K.TEACHER_AVAILABLE_ASSETS]: "Tài sản sẵn dùng",
    [K.TEACHER_READY_FOR_USE]: "Tình trạng tốt và sẵn sàng sử dụng",
    [K.TEACHER_ACTIVE_ASSIGNMENTS]: "Phân công đang hoạt động",
    [K.TEACHER_IN_STUDENT_HANDS]: "Hiện đang do học viên sử dụng",
    [K.TEACHER_OPEN_REPORTS]: "Báo cáo mở",
    [K.TEACHER_REPORTED_ISSUES]: "Sự cố do giảng viên/học viên báo",
    [K.TEACHER_ASSIGN_TITLE]: "Phân công tài sản cho học viên",
    [K.TEACHER_STUDENT_ID]: "Mã học viên",
    [K.TEACHER_SELECT_CLASS]: "Chọn lớp",
    [K.TEACHER_SELECT_AVAILABLE_ASSET]: "Chọn tài sản sẵn dùng",
    [K.TEACHER_ASSIGN_NOW]: "Phân công ngay",
    [K.TEACHER_CHANGE_ASSET]: "Đổi tài sản",
    [K.TEACHER_REMOVE_ASSET]: "Gỡ tài sản",
    [K.TEACHER_ASSET_REMOVED_SUCCESS]: "Đã gỡ tài sản khỏi học viên.",
    [K.TEACHER_ASSET_CHANGED_SUCCESS]: "Đổi tài sản cho học viên thành công.",
    [K.TEACHER_ASSET_ALREADY_ASSIGNED]: "Tài sản này đã được gán cho học viên này.",
    [K.TEACHER_REPORT_ISSUE_TITLE]: "Báo sự cố tài sản",
    [K.TEACHER_REPORT_ISSUE_HINT]: "Gửi nhanh báo cáo sự cố cho các phiên đang diễn ra.",
    [K.TEACHER_SESSION_ID]: "Mã phiên thực hành",
    [K.TEACHER_DESCRIBE_ISSUE_IMPACT]: "Mô tả sự cố và mức ảnh hưởng",
    [K.TEACHER_SEND_ISSUE_REPORT]: "Gửi báo sự cố",
    [K.TEACHER_LIVE_ASSIGNMENTS]: "Phân công trực tiếp",
    [K.TEACHER_NO_ACTIVE_ASSIGNMENTS]: "Không có phân công đang hoạt động.",
    [K.TEACHER_ASSIGNMENT_INFO]: "Được phân công",
    [K.TEACHER_FORCE_RETURN]: "Thu hồi bắt buộc",
    [K.TEACHER_RECENT_ISSUES]: "Luồng sự cố gần đây",
    [K.TEACHER_NO_ISSUES]: "Chưa có sự cố nào được báo.",
    [K.TEACHER_SESSION_LABEL]: "Phiên",
    [K.TEACHER_RESOLVED]: "Đã xử lý",
    [K.TEACHER_OPEN]: "Đang mở",
    [K.TEACHER_NO_DETAILS]: "Không có chi tiết.",
    [K.TEACHER_CLASS_START]: "Lớp bắt đầu",
    [K.TEACHER_CLASS_END]: "Lớp kết thúc",
    [K.TEACHER_TRAINING_CALENDAR]: "Lịch đào tạo",
    [K.TEACHER_NO_EVENTS_ON_DATE]: "Không có sự kiện đào tạo trong ngày đã chọn.",

    [K.MAINTAINER_LOAD_FAILED]: "Tải không gian làm việc bảo trì thất bại",
    [K.MAINTAINER_STATUS_UPDATED]: "Đã cập nhật trạng thái tài sản.",
    [K.MAINTAINER_STATUS_UPDATE_FAILED]: "Cập nhật trạng thái thất bại",
    [K.MAINTAINER_RESOLVE_SUCCESS]: "Sự cố #{id} đã được đánh dấu xử lý.",
    [K.MAINTAINER_RESOLVE_FAILED]: "Xử lý sự cố thất bại",
    [K.MAINTAINER_DEFAULT_CAUSE]: "Máy móc",
    [K.MAINTAINER_DEFAULT_RESOLUTION]: "Đã xử lý theo quy trình bảo trì.",
    [K.MAINTAINER_OPEN_REPORTS]: "Báo cáo mở",
    [K.MAINTAINER_AWAITING_DECISION]: "Đang chờ quyết định từ bảo trì",
    [K.MAINTAINER_TRACKED_ASSETS]: "Tài sản theo dõi",
    [K.MAINTAINER_ALL_STATUSES_VISIBLE]: "Hiển thị toàn bộ trạng thái",
    [K.MAINTAINER_ASSETS_IN_USE]: "Tài sản đang sử dụng",
    [K.MAINTAINER_PROTECTED_TRANSITIONS]: "Được bảo vệ khỏi chuyển trạng thái rủi ro",
    [K.MAINTAINER_STATUS_CONTROL_TITLE]: "Điều khiển trạng thái tài sản",
    [K.MAINTAINER_STATUS_CONTROL_HINT]: "Chuyển trạng thái vận hành của tài sản an toàn.",
    [K.MAINTAINER_SELECT_ASSET]: "Chọn tài sản",
    [K.MAINTAINER_NA]: "Không có",
    [K.MAINTAINER_APPLY_STATUS]: "Áp dụng thay đổi trạng thái",
    [K.MAINTAINER_OPEN_ISSUE_QUEUE]: "Hàng đợi sự cố mở",
    [K.MAINTAINER_NO_OPEN_ISSUES]: "Hiện không có sự cố mở.",
    [K.MAINTAINER_ISSUE_SESSION_LABEL]: "Sự cố",
    [K.MAINTAINER_NO_DESCRIPTION]: "Không có mô tả",
    [K.MAINTAINER_RESOLVE]: "Xử lý",
    [K.MAINTAINER_STATUS_DISTRIBUTION]: "Phân bố trạng thái",
    [K.MAINTAINER_STATUS_OPERATIONAL]: "Vận hành",
    [K.MAINTAINER_STATUS_MAINTENANCE]: "Đang bảo trì",
    [K.MAINTAINER_STATUS_BROKEN]: "Hỏng",
    [K.MAINTAINER_STATUS_LOANED]: "Đang cho mượn",
    [K.MAINTAINER_STATUS_RETIRED]: "Ngừng sử dụng",
    [K.MAINTAINER_REPORTER]: "Người báo cáo",
    [K.MAINTAINER_CATEGORY_LABEL]: "Danh mục",
    [K.MAINTAINER_DATETIME_LABEL]: "Thời điểm báo cáo",
    [K.MAINTAINER_ROOM_LABEL]: "Phòng",
    [K.MAINTAINER_ASSET_LABEL]: "Thiết bị",
    [K.MAINTAINER_RESOLUTION_FORM_TITLE]: "Xử lý sự cố",
    [K.MAINTAINER_RESOLUTION_TYPE]: "Loại xử lý",
    [K.MAINTAINER_SELECT_RESOLUTION]: "Chọn loại xử lý",
    [K.MAINTAINER_RESOLUTION_DETAIL]: "Chi tiết thao tác xử lý",
    [K.MAINTAINER_RESOLUTION_DETAIL_PLACEHOLDER]: "Mô tả chi tiết những gì đã thực hiện để khắc phục sự cố...",
    [K.MAINTAINER_CANCEL]: "Hủy",
    [K.MAINTAINER_SUBMIT_RESOLUTION]: "Đánh dấu đã giải quyết",

    // Phase 14 lifecycle (VI)
    MAINTAINER_STATUS_PENDING: "Chờ bảo dưỡng",
    MAINTAINER_INCIDENT_CALENDAR: "Lịch sự cố",
    MAINTAINER_INCIDENT_DETAILS: "Chi tiết sự cố",
    MAINTAINER_NO_EVENTS_ON_DATE: "Không có sự cố trong ngày đã chọn.",
    MAINTAINER_JOB_INCIDENT: "Sự cố",
    MAINTAINER_JOB_SCHEDULED: "Theo lịch",
    MAINTAINER_JOB_STATUS_PENDING: "Chờ kỹ thuật viên",
    MAINTAINER_JOB_STATUS_IN_PROGRESS: "Đang xử lý",
    MAINTAINER_START_WORK: "Bắt đầu xử lý",
    MAINTAINER_START_WORK_SUCCESS: "Đã bắt đầu. Tài sản đang bảo dưỡng.",
    MAINTAINER_START_WORK_FAILED: "Không thể bắt đầu xử lý",
    MAINTAINER_DECOMMISSION: "Tiêu hủy",
    MAINTAINER_DECOMMISSION_SUCCESS: "Tài sản đã được tiêu hủy.",
    MAINTAINER_DECOMMISSION_FAILED: "Tiêu hủy thất bại",
    MAINTAINER_DECOMMISSION_FORM_TITLE: "Tiêu hủy tài sản",
    MAINTAINER_DECOMMISSION_WARNING: "Hành động này không thể hoàn tác. Tài sản sẽ bị ngừng sử dụng vĩnh viễn.",
    MAINTAINER_DECOMMISSION_REASON_PLACEHOLDER: "Nêu lý do tiêu hủy tài sản này...",
    MAINTAINER_CONFIRM_DECOMMISSION: "Xác nhận tiêu hủy",
    MAINTAINER_RESOLVE_SUCCESS_LIFECYCLE: "Đã giải quyết. Tài sản đã hoạt động trở lại.",
    MAINTAINER_QUEUE_HINT: "Hiển thị cả sự cố và bảo dưỡng theo lịch.",
    MAINTAINER_JOB_LABEL: "Công việc",
    MAINTAINER_ASSIGNED_TO: "Phụ trách",
    MAINTAINER_SLA_DUE: "Hạn SLA",

    [K.INCIDENT_CATEGORY]: "Danh mục sự cố",
    [K.INCIDENT_SELECT_CATEGORY]: "Chọn danh mục sự cố",

    [K.ADMIN_TABLE_FETCH_FAILED]: "Không thể tải",
    [K.ADMIN_TABLE_SAVE_FAILED]: "Không thể lưu",
    [K.ADMIN_TABLE_DELETE_FAILED]: "Không thể xóa",
    [K.ADMIN_TABLE_UNKNOWN_ERROR]: "Lỗi không xác định",
    [K.ADMIN_TABLE_CREATED_SUCCESSFULLY]: "đã tạo thành công",
    [K.ADMIN_TABLE_UPDATED_SUCCESSFULLY]: "đã cập nhật thành công",
    [K.ADMIN_TABLE_DELETED_SUCCESSFULLY]: "đã xóa thành công",
    [K.ADMIN_TABLE_DELETED_SELECTED]: "Đã xóa các mục đã chọn",
    [K.ADMIN_TABLE_DELETE_SELECTED_FAILED]: "Không thể xóa các mục đã chọn",
    [K.ADMIN_TABLE_CONFIRM_DELETE_CATEGORY]: "Bạn có chắc muốn xóa danh mục này không?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_DEPARTMENT]: "Bạn có chắc muốn xóa phòng ban này không?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_COURSE]: "Bạn có chắc muốn xóa khóa học này không?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_CLASS]: "Bạn có chắc muốn xóa lớp học này không?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_MAPPING]: "Bạn có chắc muốn xóa ánh xạ này không?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_LINE]: "Bạn có chắc muốn xóa chuyền sản xuất này không?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_ORDER]: "Bạn có chắc muốn xóa lệnh sản xuất này không?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_PRODUCTION_STEP]: "Bạn có chắc muốn xóa công đoạn sản xuất này không?",
    [K.ADMIN_TABLE_PRODUCTION_ORDER]: "Lệnh sản xuất",
    [K.ADMIN_TABLE_PRODUCTION_ORDERS]: "Lệnh sản xuất",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_NAME]: "Tên lệnh",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_CODE]: "Mã lệnh",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_BATCH_NUMBER]: "Số lô",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_LOT_NUMBER]: "Số lot",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_TARGET_QUANTITY]: "Số lượng mục tiêu",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_PRIORITY]: "Ưu tiên",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_PLANNED_START]: "Bắt đầu kế hoạch",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_PLANNED_END]: "Kết thúc kế hoạch",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_ACTUAL_START]: "Bắt đầu thực tế",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_ACTUAL_END]: "Kết thúc thực tế",
    [K.ADMIN_TABLE_PRODUCTION_ORDER_SHIFT_CODE]: "Mã ca",
    [K.ADMIN_TABLE_ENTER_PRODUCTION_ORDER_NAME]: "Nhập tên lệnh",
    [K.ADMIN_TABLE_ENTER_PRODUCTION_ORDER_CODE]: "Nhập mã lệnh (vd: ORD-001)",
    [K.ADMIN_TABLE_SELECT_PRODUCTION_ORDER]: "Chọn lệnh sản xuất",
    [K.ADMIN_TABLE_PRODUCTION_STEP]: "Công đoạn",
    [K.ADMIN_TABLE_PRODUCTION_STEPS]: "Công đoạn sản xuất",
    [K.ADMIN_TABLE_PRODUCTION_STEP_NAME]: "Tên công đoạn",
    [K.ADMIN_TABLE_PRODUCTION_STEP_CODE]: "Mã công đoạn",
    [K.ADMIN_TABLE_PRODUCTION_STEP_SEQUENCE]: "Thứ tự",
    [K.ADMIN_TABLE_ENTER_PRODUCTION_STEP_NAME]: "Nhập tên công đoạn",
    [K.ADMIN_TABLE_ENTER_PRODUCTION_STEP_CODE]: "Nhập mã công đoạn",
    [K.ADMIN_TABLE_ADD]: "Thêm",
    [K.ADMIN_TABLE_ADD_NEW]: "Thêm mới",
    [K.ADMIN_TABLE_CREATE]: "Tạo",
    [K.ADMIN_TABLE_CREATE_NEW]: "Tạo mới",
    [K.ADMIN_TABLE_UPDATE]: "Cập nhật",
    [K.ADMIN_TABLE_CANCEL]: "Hủy",
    [K.ADMIN_TABLE_EDIT]: "Sửa",
    [K.ADMIN_TABLE_DELETE]: "Xóa",
    [K.ADMIN_TABLE_ACTIONS]: "Thao tác",
    [K.ADMIN_TABLE_LOADING]: "Đang tải...",
    [K.ADMIN_TABLE_ALL]: "Tất cả",
    [K.ADMIN_TABLE_NA]: "Không có",
    [K.ADMIN_TABLE_YES]: "Có",
    [K.ADMIN_TABLE_NO]: "Không",
    [K.ADMIN_TABLE_OPTIONAL]: "Tùy chọn",
    [K.ADMIN_TABLE_REQUIRED]: "Bắt buộc",
    [K.ADMIN_TABLE_CODE]: "Mã",
    [K.ADMIN_TABLE_NAME]: "Tên",
    [K.ADMIN_TABLE_DESCRIPTION]: "Mô tả",
    [K.ADMIN_TABLE_STATUS]: "Trạng thái",
    [K.ADMIN_TABLE_STATUSES]: "Trạng thái",
    [K.ADMIN_TABLE_ACTIVE]: "Hoạt động",
    [K.ADMIN_TABLE_IN_USE]: "Đang sử dụng",
    [K.ADMIN_TABLE_INACTIVE]: "Ngừng hoạt động",
    [K.ADMIN_TABLE_CATEGORY]: "Danh mục",
    [K.ADMIN_TABLE_CATEGORIES]: "danh mục",
    [K.ADMIN_TABLE_CATEGORY_NAME]: "Tên danh mục",
    [K.ADMIN_TABLE_DEPARTMENT]: "Phòng ban",
    [K.ADMIN_TABLE_DEPARTMENTS]: "phòng ban",
    [K.ADMIN_TABLE_DEPARTMENT_CODE]: "Mã phòng ban",
    [K.ADMIN_TABLE_DEPARTMENT_NAME]: "Tên phòng ban",
    [K.ADMIN_TABLE_COURSE]: "Khóa học",
    [K.ADMIN_TABLE_COURSES]: "khóa học",
    [K.ADMIN_TABLE_COURSE_NAME]: "Tên khóa học",
    [K.ADMIN_TABLE_COURSE_CODE]: "Mã khóa học",
    [K.ADMIN_TABLE_CLASS]: "Lớp học",
    [K.ADMIN_TABLE_CLASSES]: "lớp học",
    [K.ADMIN_TABLE_CLASS_NAME]: "Tên lớp học",
    [K.ADMIN_TABLE_CLASS_CODE]: "Mã lớp học",
    [K.ADMIN_TABLE_ASSET]: "Tài sản",
    [K.ADMIN_TABLE_MAPPING]: "Ánh xạ",
    [K.ADMIN_TABLE_MAPPINGS]: "ánh xạ",
    [K.ADMIN_TABLE_PRODUCTION_LINE]: "Chuyền sản xuất",
    [K.ADMIN_TABLE_PRODUCTION_LINES]: "chuyền sản xuất",
    [K.ADMIN_TABLE_DURATION_HOURS]: "Thời lượng (giờ)",
    [K.ADMIN_TABLE_START_DATE]: "Ngày bắt đầu",
    [K.ADMIN_TABLE_END_DATE]: "Ngày kết thúc",
    [K.ADMIN_TABLE_MAX_STUDENTS]: "Số học viên tối đa",
    [K.ADMIN_TABLE_CANCEL_ENROLLMENT_WINDOW_DAYS]: "Thời hạn rút đăng ký (số ngày trước ngày bắt đầu)",
    [K.ADMIN_TABLE_LINE_NAME]: "Tên chuyền",
    [K.ADMIN_TABLE_LINE_CODE]: "Mã chuyền",
    [K.ADMIN_TABLE_ORDER_CODE]: "Mã lệnh",
    [K.ADMIN_TABLE_CAPACITY]: "Công suất",
    [K.ADMIN_TABLE_SEARCH_NAME_DESCRIPTION]: "Tìm theo tên, mô tả",
    [K.ADMIN_TABLE_SEARCH_CODE_NAME]: "Tìm theo mã, tên",
    [K.ADMIN_TABLE_SEARCH_NAME_CODE]: "Tìm theo tên, mã",
    [K.ADMIN_TABLE_SEARCH_ASSET_COURSE]: "Tìm theo tài sản, khóa học",
    [K.ADMIN_TABLE_SEARCH_NAME_EMAIL_DEPARTMENT]: "Tìm theo tên, email, phòng ban",
    [K.ADMIN_TABLE_SEARCH_DELIVERED_RECEIVED_BY]: "Tìm người giao, người nhận",
    [K.ADMIN_TABLE_ENTER_COURSE_NAME]: "Nhập tên khóa học",
    [K.ADMIN_TABLE_ENTER_COURSE_CODE_EXAMPLE]: "Nhập mã khóa học (ví dụ: CS101)",
    [K.ADMIN_TABLE_ENTER_COURSE_DESCRIPTION]: "Nhập mô tả khóa học",
    [K.ADMIN_TABLE_ENTER_DURATION_HOURS]: "Nhập thời lượng theo giờ",
    [K.ADMIN_TABLE_SELECT_COURSE]: "Chọn một khóa học",
    [K.ADMIN_TABLE_SELECT_ASSET]: "Chọn một tài sản",
    [K.ADMIN_TABLE_SELECT_DEPARTMENT]: "Chọn phòng ban",
    [K.ADMIN_TABLE_REQUIRED_FOR_COURSE]: "Bắt buộc cho khóa học",
    [K.ADMIN_TABLE_ENTER_CLASS_NAME]: "Nhập tên lớp học",
    [K.ADMIN_TABLE_ENTER_CLASS_CODE]: "Nhập mã lớp học",
    [K.ADMIN_TABLE_ENTER_CLASS_DESCRIPTION]: "Nhập mô tả lớp học",
    [K.ADMIN_TABLE_ENTER_MAX_STUDENTS]: "Nhập số học viên tối đa",
    [K.ADMIN_TABLE_ENTER_CANCEL_ENROLLMENT_WINDOW_DAYS]: "Nhập số ngày",
    [K.ADMIN_TABLE_ENTER_LINE_NAME]: "Nhập tên chuyền",
    [K.ADMIN_TABLE_ENTER_LINE_CODE]: "Nhập mã chuyền",
    [K.ADMIN_TABLE_ENTER_ORDER_CODE]: "Nhập mã lệnh",
    [K.ADMIN_TABLE_ENTER_CAPACITY]: "Nhập công suất",
    [K.ADMIN_TABLE_UNKNOWN]: "Không xác định",
    [K.ADMIN_TABLE_DATE]: "Ngày",
    [K.ADMIN_TABLE_TYPE]: "Loại",
    [K.ADMIN_TABLE_TYPES]: "Các loại",
    [K.ADMIN_TABLE_NOTES]: "Ghi chú",
    [K.ADMIN_TABLE_PROGRESS]: "Tiến độ",
    [K.ADMIN_TABLE_QUANTITY]: "Số lượng",
    [K.ADMIN_TABLE_UNIT_PRICE]: "Đơn giá",
    [K.ADMIN_TABLE_BRAND]: "Thương hiệu",
    [K.ADMIN_TABLE_MODEL]: "Mẫu",
    [K.ADMIN_TABLE_SPECIFICATION]: "Thông số",
    [K.ADMIN_TABLE_ASSET_CODE]: "Mã tài sản",
    [K.ADMIN_TABLE_ASSET_NAME]: "Tên tài sản",
    [K.ADMIN_TABLE_SELECT_CATEGORY]: "Chọn danh mục",
    [K.ADMIN_TABLE_SELECT_UNIT]: "Chọn đơn vị",
    [K.ADMIN_TABLE_SELECT_STATUS_OPTIONAL]: "Chọn trạng thái (tùy chọn)",
    [K.ADMIN_TABLE_SELECT_COUNTRY_OF_ORIGIN_OPTIONAL]: "Chọn xuất xứ (tùy chọn)",
    [K.ADMIN_TABLE_SEARCH_CODE_NAME_BRAND_MODEL]: "Tìm mã, tên, thương hiệu, mẫu",
    [K.ADMIN_TABLE_ROOM]: "Phòng",
    [K.ADMIN_TABLE_ROOM_NAME]: "Tên phòng",
    [K.ADMIN_TABLE_ROOM_ASSETS]: "Tài sản trong phòng",
    [K.ADMIN_TABLE_WORKING_ASSETS]: "Tài sản sản xuất",
    [K.ADMIN_TABLE_ADD_ASSET_TO_ROOM]: "Thêm tài sản vào phòng",
    [K.ADMIN_TABLE_ASSET_CREATION_HANDOVER_ONLY]: "Việc tạo tài sản hiện chỉ thực hiện tại màn hình Bàn giao. Vui lòng tạo tài sản phòng mới từ màn hình Bàn giao.",
    [K.ADMIN_TABLE_WORKING_ASSET_CREATION_HANDOVER_ONLY]: "Việc tạo tài sản sản xuất hiện chỉ thực hiện tại màn hình Bàn giao. Vui lòng tạo tài sản chuyền mới từ màn hình Bàn giao.",
    [K.ADMIN_TABLE_CURRENT_ASSETS]: "Tài sản hiện tại",
    [K.ADMIN_TABLE_SERIAL]: "Số sê-ri",
    [K.ADMIN_TABLE_SERIAL_NUMBER]: "Số sê-ri",
    [K.ADMIN_TABLE_SERIAL_NUMBERS]: "Danh sách số sê-ri",
    [K.ADMIN_TABLE_SERIAL_NUMBERS_HINT]: "Nhập mỗi số sê-ri trên một dòng (hoặc phân tách bằng dấu phẩy). Số lượng phải khớp với số lượng bàn giao.",
    [K.ADMIN_TABLE_SERIAL_NUMBER_EXAMPLE]: "ví dụ: SN-12345",
    [K.ADMIN_TABLE_CONDITION]: "Tình trạng",
    [K.ADMIN_TABLE_SELECT_CONDITION_OPTIONAL]: "Chọn tình trạng (tùy chọn)",
    [K.ADMIN_TABLE_REMARKS]: "Ghi chú thêm",
    [K.ADMIN_TABLE_ADDITIONAL_REMARKS]: "Ghi chú bổ sung...",
    [K.ADMIN_TABLE_QR_CODE]: "Mã QR",
    [K.ADMIN_TABLE_VIEW_QR]: "Xem QR",
    [K.ADMIN_TABLE_SPARE_PARTS]: "Phụ tùng dự phòng",
    [K.ADMIN_TABLE_NO_LOCATION]: "Không có vị trí",
    [K.ADMIN_TABLE_LOCATION]: "Vị trí",
    [K.ADMIN_TABLE_REFRESH]: "Làm mới",
    [K.ADMIN_TABLE_SEARCH]: "Tìm kiếm...",
    [K.ADMIN_TABLE_DATE_ASSIGNED]: "Ngày bàn giao",
    [K.ADMIN_TABLE_ASSIGNED_TO]: "Đang giao cho",
    [K.ADMIN_TABLE_ASSIGNED_STUDENT]: "Học viên",
    [K.ADMIN_TABLE_ASSIGNED_WORKER]: "Công nhân",
    [K.ADMIN_TABLE_MUST_UNASSIGN_FIRST]: "cần thu hồi trước",
    [K.ASSET_TYPE_SPARE]: "Dự phòng",
    [K.ASSET_TYPE_ROOM]: "Phòng học",
    [K.ASSET_TYPE_PRODUCTION]: "Sản xuất",
    [K.ADMIN_TABLE_ASSET_QR_CODE]: "Mã QR tài sản",
    [K.ADMIN_TABLE_REMOVE]: "Gỡ",
    [K.ADMIN_TABLE_ASSET_ADDED_TO_ROOM_SUCCESSFULLY]: "Thêm tài sản vào phòng thành công",
    [K.ADMIN_TABLE_ASSET_ADDED_TO_ROOM_SUCCESSFULLY_QR]: "Thêm tài sản vào phòng thành công. QR: {qr}",
    [K.ADMIN_TABLE_CONFIRM_DELETE_ASSET]: "Bạn có chắc muốn xóa tài sản này không?",
    [K.ADMIN_TABLE_FAILED_ADD_ASSET]: "Thêm tài sản thất bại",
    [K.ADMIN_TABLE_FAILED_REMOVE_ASSET]: "Gỡ tài sản thất bại",
    [K.ADMIN_TABLE_CONFIRM_DELETE_ROOM]: "Bạn có chắc muốn xóa phòng này không?",
    [K.ADMIN_TABLE_CONFIRM_REMOVE_ASSET_FROM_ROOM]: "Bạn có chắc muốn gỡ tài sản này khỏi phòng không?",
    [K.ADMIN_TABLE_ASSIGNMENT]: "Phân công",
    [K.ADMIN_TABLE_ASSIGNMENTS]: "các phân công",
    [K.ADMIN_TABLE_STUDENT_CODE]: "Mã học viên",
    [K.ADMIN_TABLE_SEARCH_STUDENT_CODE_ASSET_CODE]: "Tìm mã học viên, mã tài sản",
    [K.ADMIN_TABLE_WORKER]: "Công nhân",
    [K.ADMIN_TABLE_EQUIPMENT]: "Thiết bị",
    [K.ADMIN_TABLE_SELECT_WORKER]: "Chọn công nhân",
    [K.ADMIN_TABLE_SELECT_EQUIPMENT]: "Chọn thiết bị",
    [K.ADMIN_TABLE_ASSIGNED_DATE]: "Ngày phân công",
    [K.ADMIN_TABLE_UNASSIGNED_DATE]: "Ngày hủy phân công",
    [K.ADMIN_TABLE_UNASSIGNED_DATE_OPTIONAL]: "Ngày hủy phân công (tùy chọn)",
    [K.ADMIN_TABLE_UNASSIGNED]: "Đã hủy phân công",
    [K.ADMIN_TABLE_SEARCH_WORKER_EQUIPMENT]: "Tìm công nhân, thiết bị",
    [K.ADMIN_TABLE_ADD_WORKER_EQUIPMENT_ASSIGNMENT]: "Thêm phân công thiết bị cho công nhân",
    [K.ADMIN_TABLE_EDIT_WORKER_EQUIPMENT_ASSIGNMENT]: "Sửa phân công thiết bị công nhân",
    [K.ADMIN_TABLE_CONFIRM_DELETE_ASSIGNMENT]: "Bạn có chắc muốn xóa phân công này không?",
    [K.ADMIN_TABLE_REFERENCE_VALIDATION_ERRORS]: "Không thể lưu phân công do lỗi tham chiếu:",
    [K.ADMIN_TABLE_HANDOVER]: "Bàn giao",
    [K.ADMIN_TABLE_HANDOVER_DATE]: "Ngày bàn giao",
    [K.ADMIN_TABLE_HANDOVER_DETAILS]: "Chi tiết bàn giao",
    [K.ADMIN_TABLE_ADD_ASSET_TO_HANDOVER]: "Thêm tài sản vào bàn giao",
    [K.ADMIN_TABLE_ADD_DETAIL]: "Thêm chi tiết",
    [K.ADMIN_TABLE_CURRENT_DETAILS]: "Chi tiết hiện tại",
    [K.ADMIN_TABLE_DETAILS]: "Chi tiết",
    [K.ADMIN_TABLE_DELIVERED_BY]: "Người giao",
    [K.ADMIN_TABLE_RECEIVED_BY]: "Người nhận",
    [K.ADMIN_TABLE_SELECT_ROOM]: "Chọn phòng",
    [K.ADMIN_TABLE_TARGET_PRODUCTION_LINE_OPTIONAL]: "Chuyền sản xuất mục tiêu (tùy chọn)",
    [K.ADMIN_TABLE_NONE_ROOM_ASSET_ONLY]: "Không chọn (chỉ tạo tài sản phòng)",
    [K.ADMIN_TABLE_TARGET_LOCATION]: "Đích nhận",
    [K.ADMIN_TABLE_SELECT_TARGET_LOCATION]: "Chọn đích nhận",
    [K.ADMIN_TABLE_QUANTITY_EXAMPLE]: "ví dụ: 5",
    [K.ADMIN_TABLE_SERIAL_COUNT_MUST_MATCH_QUANTITY]: "Số lượng số sê-ri phải khớp với số lượng",
    [K.ADMIN_TABLE_ASSET_AND_SERIAL_REQUIRED]: "Bắt buộc chọn tài sản và nhập số sê-ri",
    [K.ADMIN_TABLE_SERIAL_ALREADY_STAGED]: "Số sê-ri này đã được thêm",
    [K.ADMIN_TABLE_TARGET_REQUIRED]: "Vui lòng chọn đích nhận",
    [K.ADMIN_TABLE_ADD_ITEM]: "Thêm",
    [K.ADMIN_TABLE_STAGED_ITEMS]: "Danh sách mục đã thêm",
    [K.ADMIN_TABLE_STAGED_ITEMS_EMPTY]: "Chưa có mục nào được thêm",
    [K.ADMIN_TABLE_PENDING_GROUPED_SUMMARY]: "Tổng hợp nhóm chờ tạo",
    [K.ADMIN_TABLE_CONDITION_AT_HANDOVER]: "Tình trạng khi bàn giao",
    [K.ADMIN_TABLE_CONDITION_EXAMPLE]: "ví dụ: Tốt, Khá, Kém",
    [K.ADMIN_TABLE_DETAIL_ADDED_SUCCESSFULLY]: "Thêm chi tiết thành công",
    [K.ADMIN_TABLE_DETAIL_DELETED_SUCCESSFULLY]: "Xóa chi tiết thành công",
    [K.ADMIN_TABLE_FAILED_ADD_DETAIL]: "Thêm chi tiết thất bại",
    [K.ADMIN_TABLE_FAILED_DELETE_DETAIL]: "Xóa chi tiết thất bại",
    [K.ADMIN_TABLE_CONFIRM_DELETE_HANDOVER]: "Bạn có chắc muốn xóa bản bàn giao này không?",
    [K.ADMIN_TABLE_CONFIRM_DELETE_DETAIL]: "Bạn có chắc muốn xóa chi tiết này không?",
    [K.ADMIN_TABLE_USAGE_LOG]: "Nhật ký sử dụng",
    [K.ADMIN_TABLE_USAGE_LOGS]: "các nhật ký sử dụng",
    [K.ADMIN_TABLE_LOG_EQUIPMENT_USAGE]: "Ghi nhận sử dụng thiết bị",
    [K.ADMIN_TABLE_LOG_USAGE]: "Ghi nhận",
    [K.ADMIN_TABLE_START_TIME]: "Thời gian bắt đầu",
    [K.ADMIN_TABLE_END_TIME]: "Thời gian kết thúc",
    [K.ADMIN_TABLE_END_TIME_OPTIONAL]: "Thời gian kết thúc (tùy chọn)",
    [K.ADMIN_TABLE_RUNNING_MINUTES]: "Phút chạy",
    [K.ADMIN_TABLE_RUNNING_MINUTES_EXAMPLE]: "ví dụ: 480",
    [K.ADMIN_TABLE_DOWNTIME_MINUTES]: "Phút dừng máy",
    [K.ADMIN_TABLE_DOWNTIME_MINUTES_EXAMPLE]: "ví dụ: 30",
    [K.ADMIN_TABLE_STITCH_COUNT_OPTIONAL]: "Số mũi may (tùy chọn)",
    [K.ADMIN_TABLE_STITCH_COUNT_EXAMPLE]: "ví dụ: 5000",
    [K.ADMIN_TABLE_ADD_NOTES_USAGE]: "Thêm ghi chú về việc sử dụng",
    [K.ADMIN_TABLE_SELECT_PRODUCTION_LINE]: "Chọn chuyền sản xuất",
    [K.ADMIN_TABLE_SELECT_PRODUCTION_LINE_FIRST]: "Chọn chuyền sản xuất trước",
    [K.ADMIN_TABLE_CONFIRM_DELETE_USAGE_LOG]: "Bạn có chắc muốn xóa nhật ký sử dụng này không?",
    [K.ADMIN_TABLE_REFERENCE_VALIDATION_ERRORS_USAGE_LOG]: "Không thể lưu nhật ký sử dụng do lỗi tham chiếu:",
    [K.ADMIN_TABLE_EDIT_USAGE_LOG]: "Sửa nhật ký sử dụng",
    [K.ADMIN_TABLE_SCHEDULE]: "Lịch",
    [K.ADMIN_TABLE_SCHEDULES]: "các lịch",
    [K.ADMIN_TABLE_FREQUENCY]: "Tần suất",
    [K.ADMIN_TABLE_FREQUENCY_DAYS_HOURS]: "{value} ngày/giờ",
    [K.ADMIN_TABLE_FREQUENCY_DAYS_OR_HOURS]: "Tần suất (ngày hoặc giờ)",
    [K.ADMIN_TABLE_LAST_MAINTENANCE]: "Bảo trì gần nhất",
    [K.ADMIN_TABLE_LAST_MAINTENANCE_DATE]: "Ngày bảo trì gần nhất",
    [K.ADMIN_TABLE_NEXT_DUE]: "Hạn kế tiếp",
    [K.ADMIN_TABLE_NEXT_DUE_DATE]: "Ngày đến hạn kế tiếp",
    [K.ADMIN_TABLE_SELECT_MAINTENANCE_TYPE]: "Chọn loại bảo trì",
    [K.ADMIN_TABLE_ADD_MAINTENANCE_SCHEDULE]: "Thêm lịch bảo trì",
    [K.ADMIN_TABLE_EDIT_MAINTENANCE_SCHEDULE]: "Sửa lịch bảo trì",
    [K.ADMIN_TABLE_ADD_NEW_MAINTENANCE_SCHEDULE]: "Thêm lịch bảo trì mới",
    [K.ADMIN_TABLE_SEARCH_ASSET_DESCRIPTION]: "Tìm tài sản, mô tả",
    [K.ADMIN_TABLE_CONFIRM_DELETE_SCHEDULE]: "Bạn có chắc muốn xóa lịch này không?",
    [K.ADMIN_TABLE_RECORD]: "Phiếu",
    [K.ADMIN_TABLE_RECORDS]: "các phiếu",
    [K.ADMIN_TABLE_MAINTENANCE_DATE]: "Ngày bảo trì",
    [K.ADMIN_TABLE_DURATION_MIN]: "Thời lượng (phút)",
    [K.ADMIN_TABLE_REPAIR_DURATION_MINUTES]: "Thời gian sửa chữa (phút)",
    [K.ADMIN_TABLE_ROOT_CAUSE]: "Nguyên nhân gốc",
    [K.ADMIN_TABLE_TECHNICIAN]: "Kỹ thuật viên",
    [K.ADMIN_TABLE_COMPLETION_STATUSES]: "Trạng thái hoàn tất",
    [K.ADMIN_TABLE_SELECT_TECHNICIAN_OPTIONAL]: "Chọn kỹ thuật viên (tùy chọn)",
    [K.ADMIN_TABLE_SELECT_FAILURE_CATEGORY_OPTIONAL]: "Chọn nhóm lỗi (tùy chọn)",
    [K.ADMIN_TABLE_SELECT_COMPLETION_STATUS_OPTIONAL]: "Chọn trạng thái hoàn tất (tùy chọn)",
    [K.ADMIN_TABLE_ADD_MAINTENANCE_RECORD]: "Thêm phiếu bảo trì",
    [K.ADMIN_TABLE_EDIT_MAINTENANCE_RECORD]: "Sửa phiếu bảo trì",
    [K.ADMIN_TABLE_ADD_NEW_MAINTENANCE_RECORD]: "Thêm phiếu bảo trì mới",
    [K.ADMIN_TABLE_SEARCH_ASSET_TECHNICIAN_ROOT_CAUSE]: "Tìm tài sản, kỹ thuật viên, nguyên nhân",
    [K.ADMIN_TABLE_CONFIRM_DELETE_RECORD]: "Bạn có chắc muốn xóa phiếu này không?",
    [K.ADMIN_TABLE_PART]: "Linh kiện",
    [K.ADMIN_TABLE_PARTS]: "các linh kiện",
    [K.ADMIN_TABLE_PART_CODE]: "Mã linh kiện",
    [K.ADMIN_TABLE_PART_NAME]: "Tên linh kiện",
    [K.ADMIN_TABLE_MANUFACTURER]: "Nhà sản xuất",
    [K.ADMIN_TABLE_MANUFACTURER_OPTIONAL]: "Nhà sản xuất (tùy chọn)",
    [K.ADMIN_TABLE_COMPATIBLE_MACHINE_TYPES]: "Loại máy tương thích (phân tách bằng dấu phẩy)",
    [K.ADMIN_TABLE_STOCK]: "Tồn kho",
    [K.ADMIN_TABLE_STOCK_QUANTITY]: "Số lượng tồn",
    [K.ADMIN_TABLE_REORDER_LEVEL]: "Mức đặt lại",
    [K.ADMIN_TABLE_ADD_NEW_SPARE_PART]: "Thêm linh kiện mới",
    [K.ADMIN_TABLE_EDIT_SPARE_PART]: "Sửa linh kiện",
    [K.ADMIN_TABLE_SEARCH_CODE_NAME_MANUFACTURER]: "Tìm mã, tên, nhà sản xuất",
    [K.ADMIN_TABLE_CONFIRM_DELETE_PART]: "Bạn có chắc muốn xóa linh kiện này không?",
    [K.ADMIN_TABLE_FULL_NAME]: "Họ và tên",
    [K.ADMIN_TABLE_EMAIL]: "Email",
    [K.ADMIN_TABLE_ROLES]: "Vai trò",
    [K.ADMIN_TABLE_NO_ROLES]: "Không có vai trò",
    [K.ADMIN_TABLE_BUSINESS_CODES]: "Mã nghiệp vụ",
    [K.ADMIN_TABLE_LAST_LOGIN]: "Đăng nhập gần nhất",
    [K.ADMIN_TABLE_NEVER]: "Chưa từng",
    [K.ADMIN_TABLE_ROLE]: "Vai trò",
    [K.ADMIN_TABLE_ASSIGN_ROLE]: "Gán vai trò",
    [K.ADMIN_TABLE_ASSIGN_ROLE_TO]: "Gán vai trò cho {name}",
    [K.ADMIN_TABLE_REMOVE_ROLE]: "Gỡ vai trò",
    [K.ADMIN_TABLE_CONFIRM_REMOVE_ROLE]: "Bạn có chắc muốn gỡ vai trò \"{role}\" khỏi người dùng này không?",
    [K.ADMIN_TABLE_ASSIGNED_SUCCESSFULLY]: "được gán thành công",
    [K.ADMIN_TABLE_REMOVED_SUCCESSFULLY]: "đã gỡ thành công",
    [K.ADMIN_TABLE_FAILED_ASSIGN_ROLE]: "Gán vai trò thất bại",
    [K.ADMIN_TABLE_FAILED_REMOVE_ROLE]: "Gỡ vai trò thất bại",
    [K.ADMIN_TABLE_EDIT_CODE]: "Sửa mã",
    [K.ADMIN_TABLE_UPDATE_CODE]: "Cập nhật mã",
    [K.ADMIN_TABLE_CODE_UPDATED_SUCCESSFULLY]: "Cập nhật mã thành công",
    [K.ADMIN_TABLE_FAILED_UPDATE_CODE]: "Cập nhật mã thất bại",
    [K.ADMIN_TABLE_ROLE_CODE]: "Mã {role}",
    [K.ADMIN_TABLE_BUSINESS_CODE_OPTIONAL]: "Mã nghiệp vụ (tùy chọn)",
    [K.ADMIN_TABLE_LEAVE_EMPTY_AUTO_GENERATION]: "Để trống để tự sinh",
    [K.ADMIN_TABLE_AUTO_CODE_EXAMPLE]: "Nếu để trống, mã sẽ được tự sinh (ví dụ: STU-000001)",
    [K.ADMIN_TABLE_EDIT_ROLE_CODE_FOR]: "Sửa mã {role} cho {name}",
    [K.ADMIN_TABLE_STUDENT]: "Học viên",
    [K.ADMIN_TABLE_INSTRUCTOR]: "Giảng viên",
    [K.ADMIN_TABLE_PRODUCTION_MANAGER]: "Quản lý sản xuất",
    [K.ADMIN_TABLE_STUDENT_ID]: "Mã học viên",
    [K.ADMIN_TABLE_ASSET_ID]: "Mã tài sản",
    [K.ADMIN_TABLE_UNASSIGN]: "Hủy phân công",
    [K.ADMIN_TABLE_CONFIRM_UNASSIGN_EQUIPMENT]: "Bạn có chắc muốn hủy phân công thiết bị này không?",
    [K.ADMIN_TABLE_EQUIPMENT_UNASSIGNED_SUCCESSFULLY]: "Hủy phân công thiết bị thành công",
    [K.ADMIN_TABLE_FAILED_UNASSIGN_EQUIPMENT]: "Hủy phân công thiết bị thất bại",
    [K.ADMIN_TABLE_SEARCH_STUDENT_ID_ASSET_ID]: "Tìm mã học viên, mã tài sản",
    [K.ADMIN_TABLE_STUDENT_ID_REQUIRED]: "Mã học viên *",
    [K.ADMIN_TABLE_ENTER_STUDENT_ID]: "Nhập mã học viên",
    [K.ADMIN_TABLE_SELECT_STUDENT]: "Chọn một học viên",
    [K.ADMIN_TABLE_ROOM_ASSET_ID_REQUIRED]: "Mã tài sản phòng *",
    [K.ADMIN_TABLE_ENTER_ROOM_ASSET_ID]: "Nhập mã tài sản phòng",
    [K.ADMIN_TABLE_SELECT_ROOM_ASSET]: "Chọn một tài sản phòng",
    [K.ADMIN_TABLE_CLASS_REQUIRED]: "Lớp *",
    [K.ADMIN_TABLE_SELECT_A_CLASS]: "Chọn một lớp",
    [K.ADMIN_TABLE_ASSIGNED_DATE_REQUIRED]: "Ngày phân công *",
    [K.ADMIN_TABLE_SELECT_INSTRUCTOR_OPTIONAL]: "Chọn giảng viên (tùy chọn)",
    [K.ADMIN_TABLE_SELECT_INSTRUCTOR_REQUIRED]: "Chọn giảng viên",
    [K.ADMIN_TABLE_INSTRUCTOR_REQUIRED]: "Giảng viên là bắt buộc.",
    [K.ADMIN_TABLE_CLASS_DAYS]: "Ngày học",
    [K.ADMIN_TABLE_TIMEFRAME_START]: "Giờ bắt đầu",
    [K.ADMIN_TABLE_TIMEFRAME_END]: "Giờ kết thúc",
    [K.ADMIN_TABLE_INVALID_TIMEFRAME]: "Mỗi nhóm lịch phải có giờ bắt đầu và kết thúc hợp lệ.",
    [K.ADMIN_TABLE_TOTAL_SCHEDULE_HOURS]: "Tổng số giờ đã xếp lịch",
    [K.ADMIN_TABLE_REQUIRED_COURSE_HOURS]: "Số giờ khóa học yêu cầu",
    [K.ADMIN_TABLE_SCHEDULE_HOURS_INSUFFICIENT]: "Tổng số giờ đã xếp lịch phải lớn hơn hoặc bằng số giờ khóa học.",
    [K.ADMIN_TABLE_SCHEDULE_GROUPS_OVERLAP]: "Các nhóm lịch không được chồng giờ trong cùng một ngày.",
    [K.ADMIN_TABLE_SELECT_AT_LEAST_ONE_DAY]: "Vui lòng chọn ít nhất một ngày học.",
    [K.ADMIN_TABLE_MON]: "T2",
    [K.ADMIN_TABLE_TUE]: "T3",
    [K.ADMIN_TABLE_WED]: "T4",
    [K.ADMIN_TABLE_THU]: "T5",
    [K.ADMIN_TABLE_FRI]: "T6",
    [K.ADMIN_TABLE_SAT]: "T7",
    [K.ADMIN_TABLE_SUN]: "CN",
    [K.ADMIN_TABLE_CHECK_TABLE]: "Bảng kiểm tra",
    [K.ADMIN_TABLE_COMPLEX_TABLE]: "Bảng phức hợp",
    [K.ADMIN_TABLE_APPROVED]: "Đã duyệt",
    [K.ADMIN_TABLE_DISABLED]: "Vô hiệu",
    [K.ADMIN_TABLE_ERROR]: "Lỗi",
    [K.ADMIN_DASHBOARD_TRAINING_CALENDAR_EVENTS]: "Sự kiện lịch đào tạo",
    [K.ADMIN_DASHBOARD_NO_EVENTS_ON_DATE]: "Không có sự kiện trong ngày đã chọn.",
    [K.ADMIN_DASHBOARD_MAINTENANCE_CALENDAR_EVENTS]: "Sự kiện bảo trì trong ngày đã chọn",

    [K.ADMIN_DASHBOARD_LOAD_FAILED]: "Không thể tải dữ liệu bảng điều khiển.",
    [K.ADMIN_DASHBOARD_TOTAL_ASSETS]: "Tổng số thiết bị",
    [K.ADMIN_DASHBOARD_ACTIVE_ASSIGNMENTS]: "Công nhân đang được phân công",
    [K.ADMIN_DASHBOARD_OVERDUE_MAINTENANCE]: "Bảo trì quá hạn",
    [K.ADMIN_DASHBOARD_LOW_STOCK_PARTS]: "Linh kiện sắp hết hàng",
    [K.ADMIN_DASHBOARD_ACTIVE_SESSIONS_TODAY]: "Buổi thực hành đang diễn ra hôm nay",
    [K.ADMIN_DASHBOARD_HANDOVERS_THIS_MONTH]: "Bàn giao trong tháng này",
    [K.ADMIN_DASHBOARD_OPEN_INCIDENTS]: "Sự cố chưa xử lý",

    [K.DASH_ASSET_STATUS_TITLE]: "Thiết bị theo trạng thái",
    [K.DASH_ASSET_STATUS_SUBTITLE]: "Phân tích trạng thái hiện tại",
    [K.DASH_ASSETS_BY_CATEGORY_TITLE]: "Thiết bị theo danh mục",
    [K.DASH_ASSETS_BY_CATEGORY_SUBTITLE]: "Cơ cấu danh mục thiết bị",
    [K.DASH_MAINTENANCE_TREND_TITLE]: "Hồ sơ bảo trì — 12 tháng qua",
    [K.DASH_MAINTENANCE_TREND_SUBTITLE]: "Xu hướng hoạt động bảo trì hàng tháng",
    [K.DASH_USAGE_TITLE]: "Sử dụng thiết bị — 30 ngày qua",
    [K.DASH_USAGE_SUBTITLE]: "Thời gian hoạt động và thời gian ngừng (phút)",
    [K.DASH_UPCOMING_MAINTENANCE_TITLE]: "Bảo trì sắp tới (30 ngày tới)",
    [K.DASH_UPCOMING_MAINTENANCE_SUBTITLE]: "Lịch bảo trì sắp đến hạn",
    [K.DASH_LOW_STOCK_TITLE]: "Linh kiện sắp hết hàng",
    [K.DASH_LOW_STOCK_SUBTITLE]: "Linh kiện ở mức tồn kho tối thiểu hoặc thấp hơn",
    [K.DASH_OVERDUE]: "Quá hạn",
    [K.DASH_UPCOMING]: "Sắp đến hạn",
    [K.DASH_OUT_OF_STOCK]: "Hết hàng",
    [K.DASH_LOW_STOCK]: "Sắp hết hàng",

    [K.ADMIN_TABLE_RECORDS]: "Hồ sơ",
    [K.ADMIN_TABLE_RUNNING_MINUTES]: "Thời gian hoạt động",
    [K.ADMIN_TABLE_DOWNTIME_MINUTES]: "Thời gian ngừng",
    [K.ADMIN_TABLE_NEXT_DUE]: "Ngày đến hạn",
    [K.ADMIN_TABLE_PART_CODE]: "Mã linh kiện",
    [K.ADMIN_TABLE_PART_NAME]: "Tên linh kiện",
    [K.ADMIN_TABLE_STOCK]: "Tồn kho",
    [K.ADMIN_TABLE_REORDER_LEVEL]: "Mức đặt hàng lại",

    [K.AUTH_BACK_TO_DASHBOARD]: "Quay lại trang chủ",
    [K.FOOTER_COPYRIGHT]: "©{year} Trường Đại học Kinh tế - Kỹ thuật Công nghiệp.",

    [K.PORTAL_ACCESS_TITLE]: "Quản lý quyền truy cập cổng",
    [K.PORTAL_ACCESS_DESCRIPTION]: "Cấp hoặc thu hồi quyền truy cập cổng bằng cách liên kết hồ sơ người dùng với vai trò Học viên / Giảng viên / Kỹ thuật viên.",
    [K.PORTAL_ACCESS_GRANT_SELECTED]: "Cấp quyền đã chọn ({count})",
    [K.PORTAL_ACCESS_REVOKE_SELECTED]: "Thu hồi đã chọn ({count})",
    [K.PORTAL_ACCESS_GRANT]: "Cấp quyền",
    [K.PORTAL_ACCESS_REVOKE]: "Thu hồi",
    [K.PORTAL_ACCESS_NO_USERS]: "Không tìm thấy người dùng",
    [K.PORTAL_ACCESS_SELECT_USER]: "Vui lòng chọn ít nhất một người dùng.",
    [K.PORTAL_ACCESS_ALREADY_GRANTED]: "Tất cả người dùng đã chọn đều có quyền truy cập {portal}.",
    [K.PORTAL_ACCESS_NONE_TO_REVOKE]: "Không có người dùng nào trong danh sách đang có quyền truy cập {portal}.",
    [K.PORTAL_ACCESS_CONFIRM_GRANT]: "Cấp quyền {portal} cho {count} người dùng?",
    [K.PORTAL_ACCESS_CONFIRM_REVOKE_BULK]: "Thu hồi quyền {portal} của {count} người dùng?",
    [K.PORTAL_ACCESS_GRANTED]: "Đã cấp quyền {portal} cho {count} người dùng.",
    [K.PORTAL_ACCESS_REVOKED]: "Đã thu hồi quyền {portal} của {count} người dùng.",
    [K.PORTAL_ACCESS_PARTIAL_GRANT]: "Đã cấp quyền {portal} cho {count} người dùng. {failed} người dùng thất bại. Xem console để biết chi tiết.",
    [K.PORTAL_ACCESS_PARTIAL_REVOKE]: "Đã thu hồi quyền {portal} của {count} người dùng. {failed} người dùng thất bại. Xem console để biết chi tiết.",
    [K.PORTAL_ACCESS_GRANT_SUCCESS]: "Cấp quyền {portal} thành công.",
    [K.PORTAL_ACCESS_REVOKE_SUCCESS]: "Thu hồi quyền {portal} thành công.",
    [K.PORTAL_ACCESS_CONFIRM_SINGLE_REVOKE]: "Thu hồi quyền {portal} của {name}?",
    [K.PORTAL_ACCESS_GRANT_FAILED]: "Cấp quyền thất bại: {error}",
    [K.PORTAL_ACCESS_REVOKE_FAILED]: "Thu hồi thất bại: {error}",
    [K.PORTAL_ACCESS_BULK_FAILED]: "Thao tác hàng loạt thất bại: {error}",
    [K.PORTAL_ACCESS_FETCH_FAILED]: "Không thể tải danh sách người dùng: {error}",
    [K.PORTAL_ACCESS_REVOKE_BLOCKED_ACTIVE_ASSET]: "Người dùng đang được gán tài sản, vui lòng hủy gán trước khi thu hồi quyền.",
    [K.PORTAL_ACCESS_REVOKE_BLOCKED_ACTIVE_ASSET_WITH_PORTAL]: "Người dùng đang được gán tài sản, vui lòng hủy gán trước khi thu hồi quyền truy cập {portal}.",
    [K.PORTAL_ACCESS_REVOKE_BLOCKED_SELECTED_ACTIVE_ASSETS]: "Một số người dùng đã chọn đang được gán tài sản. Vui lòng hủy gán trước khi thu hồi quyền truy cập cổng.",
    [K.PORTAL_ACCESS_REVOKE_BLOCKED_SELECTED_TOOLTIP]: "Một số người dùng đã chọn đang được gán tài sản nên chưa thể thu hồi quyền cho đến khi hủy gán.",

    [K.CONFIG_CATEGORIES_HEADING]: "Danh mục",
    [K.CONFIG_ADD_CATEGORY]: "Thêm danh mục",
    [K.CONFIG_ITEM_COUNT]: "({count} mục)",
    [K.CONFIG_SELECT_A_CATEGORY]: "Chọn danh mục",
    [K.CONFIG_CATEGORY_ITEMS_HEADER]: "Mục {name}",
    [K.CONFIG_ADD_ITEM]: "Thêm mục",
    [K.CONFIG_NO_ITEMS]: "Không có mục nào trong danh mục này.",
    [K.CONFIG_LABEL_LANGUAGE]: "Nhãn ({language})",
    [K.CONFIG_SORT_ORDER]: "Thứ tự sắp xếp",
    [K.CONFIG_EDIT_TRANSLATIONS_TITLE]: "Chỉnh sửa bản dịch",
    [K.CONFIG_NEW_CATEGORY]: "Danh mục mới",
    [K.CONFIG_CATEGORY_CODE_PLACEHOLDER]: "Mã danh mục (vd. TinhTrangTaiSan)",
    [K.CONFIG_DESCRIPTION_OPTIONAL]: "Mô tả (không bắt buộc)",
    [K.CONFIG_NEW_ITEM]: "Mục cấu hình mới",
    [K.CONFIG_EDIT_TRANSLATIONS_MODAL]: "Chỉnh sửa bản dịch",
    [K.CONFIG_ITEM_CODE_PLACEHOLDER]: "Mã mục (vd. PAIR)",
    [K.CONFIG_TRANSLATIONS_LABEL]: "Bản dịch",
    [K.CONFIG_LABEL_IN_LANGUAGE]: "Nhãn trong {languageName}",
    [K.CONFIG_CONFIRM_DELETE_ITEM]: "Bạn có chắc muốn xóa mục cấu hình này không?",
    [K.CONFIG_CATEGORY_CREATED]: "Tạo danh mục thành công",
    [K.CONFIG_CREATE_CATEGORY_FAILED]: "Tạo danh mục thất bại: {error}",
    [K.CONFIG_TRANSLATIONS_UPDATED]: "Cập nhật bản dịch thành công",
    [K.CONFIG_ITEM_CREATED]: "Tạo mục thành công",
    [K.CONFIG_SAVE_ITEM_FAILED]: "Lưu mục thất bại: {error}",
    [K.CONFIG_ITEM_DELETED]: "Đã xóa mục",
    [K.CONFIG_DELETE_ITEM_FAILED]: "Xóa mục thất bại: {error}",
    [K.CONFIG_FETCH_CATEGORIES_FAILED]: "Không thể tải danh mục: {error}",
    [K.NAV_NO_NOTIFICATIONS]: "Bạn không có thông báo nào",
    [K.NAV_NOTIFICATIONS_LOADING]: "Đang tải thông báo...",
    [K.NAV_NOTIFICATIONS_ERROR]: "Không thể tải thông báo",
    [K.NAV_NOTIFICATIONS_UNREAD]: "{count} chưa đọc",
  },
};

export const getFallbackBundle = (languageCode) => {
  return fallbackTranslations[languageCode] || fallbackTranslations["en-US"];
};

export default fallbackTranslations;
